import React, { useState, useEffect } from "react";
import Content from "../components/Content";
import Layout from "../containers/LayoutAdministrativo";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CachedIcon from "@mui/icons-material/Cached";
import PacientesService from "../services/PacientesService";
import ConveniosService from "../services/ConveniosService";
import SucursalesService from "../services/SucursalesService";
import EstudiosService from "../services/EstudiosService";
import CotizacionesEstudiosService from "../services/CotizacionesEstudiosService";
import PreciosEstudioService from "../services/PreciosEstudioService";
import PreciosSucursalService from "../services/PreciosSucursalService";
import CotizacionesService from "../services/CotizacionesService";
import SolicitudesService from "../services/SolicitudesService";
import MuestrasService from "../services/MuestrasService";
import EstudiosIntService from "../services/EstudiosIntService";
import TelefonosService from "../services/TelefonosService";
import HorariosAtencionService from "../services/HorariosAtencionService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoLaboratorio from "../img/logo-laboratorio.jpg";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/EditSquare";
import PrintIcon from "@mui/icons-material/Print";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { mostrarToast } from "../utils/toastUtils";
import { ejecutarConCargandoPDF } from "../utils/pdfLoadingUtils";
import { filterAndRankEstudios } from "../utils/estudioFilterUtils";
import { tieneMasDe10Digitos } from "../utils/telefonoUtils";
import Chip from '@mui/material/Chip';
import {
  CircularProgress,
  Snackbar,
  Alert,
  Grid,
  TextField,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Typography,
  OutlinedInput,
  Stack,
  Box,
  IconButton,
  Button,
  Tooltip,
  tooltipClasses,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Autocomplete,
} from "@mui/material";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const Cotizaciones = () => {
  useEffect(() => {
    document.title = "Cotizaciones";
    getPacientes();
    getConvenios();
    getSucursales();
  }, []);
  function mostrarMensaje(mensaje) {
    Swal.fire({
      title: "",
      text: mensaje,
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
  }
  function mostrarError(mensaje) {
    Swal.fire({
      title: "¡Error!",
      text: mensaje,
      icon: "error",
      confirmButtonText: "Aceptar",
    });
  }

  function reloadPage() {
    window.location.reload();
  }
  const [selectedPaciente, setSelectedPaciente] = useState(null);
  const [cantidadVisitas, setCantidadVisitas] = useState(0);

  const [pacientes, setPacientes] = useState([]);
  const [nombre, setNombre] = useState("");
  const [apPaterno, setApPaterno] = useState("");
  const [apMaterno, setApMaterno] = useState("");
  const [fechaNac, setFechaNac] = useState("");
  const [edad, setEdad] = useState("");
  const [email, setEmail] = useState("");
  const [sexo, setSexo] = useState("");
  const [telefonoCelular, setTelefonoCelular] = useState("");
  const [errorNombre, setErrorNombre] = useState(false);
  const [errorApPaterno, setErrorApPaterno] = useState(false);
  const [errorSexo, setErrorSexo] = useState(false);
  const [direccion, setDireccion] = useState("");
  const [colonia, setColonia] = useState("");
  const [cPostal, setCPostal] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [estado, setEstado] = useState("seleccione");
  const [ine, setIne] = useState("");
  const [conversion, setConversion] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [empresa, setEmpresa] = useState("");
  const [fecha, setFecha] = useState("");
  const [sucursalNombre, setSucursalNombre] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [viewOnlyE, setViewOnlyE] = useState(false);
  const [viewOnlyP, setViewOnlyP] = useState(false);
  const [viewOnly, setViewOnly] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeG, setEditModeG] = useState(false);
  const [showCotizacionPacienteHeader, setShowCotizacionPacienteHeader] =
    useState(false);
  const [cotizacionNumero, setCotizacionNumero] = useState("");
  const [cotizacionSucursalNombre, setCotizacionSucursalNombre] = useState("");
  const [cotizacionFecha, setCotizacionFecha] = useState("");
  const [cotizacionInserto, setCotizacionInserto] = useState("");
  const [cotizacionHeader, setCotizacionHeader] = useState(null);
  const [usuario, setUsuario] = useState("");
  const [estudios, setEstudios] = useState([
    {
      cantidad: "1",
      codigo: "",
      nombre: "",
      costo: "",
      idEstudio: "",
      descuento: "",
    },
  ]);
  const [sucursales, setSucursales] = useState([]);
  const [opcionDescuento, setOpcionDescuento] = useState("ninguno");
  const [valorGeneral, setValorGeneral] = useState("");
  const [errorDescuentoGeneral, setErrorDescuentoGeneral] = useState("");
  const [erroresDescuentoEstudios, setErroresDescuentoEstudios] = useState([]);
  const [estudiosOptions, setEstudiosOptions] = useState([]);
  const [preciosByLista, setPreciosByLista] = useState({});
  const [preciosSucursal, setPreciosSucursal] = useState([]);
  const [observaciones, setObservaciones] = useState("");
  const [selectedLista, setSelectedLista] = useState("");
  const [selectedCotizacionId, setSelectedCotizacionId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [saving, setSaving] = useState({
    nombre: false,
    apPaterno: false,
    apMaterno: false,
    sexo: false,
    fechaNacimiento: false,
    email: false,
    telefono: false,
  });
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    let active = true;
    if (selectedPaciente) {
      setNombre(selectedPaciente.nombre || "");
      setApPaterno(selectedPaciente.apPaterno || "");
      setApMaterno(selectedPaciente.apMaterno || "");
      setSexo(selectedPaciente.sexo || "");
      setFechaNac(selectedPaciente.fechaNacimiento || "");
      setEdad(selectedPaciente.edad || (selectedPaciente.fechaNacimiento ? calcularEdadDesdeFechaNacimiento(selectedPaciente.fechaNacimiento) : ""));
      setTelefonoCelular(selectedPaciente.telefonoCelular || "");
      setDireccion(selectedPaciente.direccion || "");
      setColonia(selectedPaciente.colonia || "");
      setCPostal(selectedPaciente.cPostal || "");
      setEstado(selectedPaciente.estado || "");
      setCiudad(selectedPaciente.ciudad);
      setIne(selectedPaciente.ine || "");
      setEmail(selectedPaciente.email || "");
      if (!editMode) {
        setViewOnlyP(true);
      }

      if (selectedPaciente.idPaciente) {
        const fetchCantidadVisitas = async () => {
          try {
            const resultado = await SolicitudesService.getSolicitudes();
            const listaSolicitudes = resultado?.data?.solicitudes || [];
            const count = listaSolicitudes.filter(
              (sol) => String(sol.idPaciente) === String(selectedPaciente.idPaciente)
            ).length;
            if (active) {
              setCantidadVisitas(count);
            }
          } catch (error) {
            console.error("Error al obtener la cantidad de visitas:", error);
            if (active) {
              setCantidadVisitas(0);
            }
          }
        };
        fetchCantidadVisitas();
      } else {
        setCantidadVisitas(0);
      }
    } else {
      setNombre("");
      setApPaterno("");
      setApMaterno("");
      setSexo("");
      setFechaNac("");
      setEdad("");
      setTelefonoCelular("");
      setDireccion("");
      setColonia("");
      setCPostal("");
      setEstado("seleccione");
      setCiudad("");
      setIne("");
      setEmail("");
      setCantidadVisitas(0);
      setViewOnly(false);
      setViewOnlyP(false);
    }
    return () => {
      active = false;
    };
  }, [selectedPaciente]);

  useEffect(() => {
    fetchEstudiosOptions();
    fetchPrecios();
  }, []);

  const parseHora = (value) => {
    if (value === null || value === undefined || value === "" || value === "seleccione") {
      return null;
    }

    const texto = `${value}`.trim();
    if (!texto.includes(":")) return null;

    const [hora, minuto] = texto.split(":");
    const horas = Number(hora);
    const minutos = Number(minuto || 0);

    if (Number.isNaN(horas) || Number.isNaN(minutos)) return null;
    return horas * 60 + minutos;
  };

  const normalizarTexto = (value) => {
    if (value === null || value === undefined) return "";
    return `${value}`.trim().toLowerCase();
  };

  const normalizarDia = (value) => {
    const texto = normalizarTexto(value)
      .replace(/\s+/g, "")
      .replace(/[áàäâ]/g, "a")
      .replace(/[éèëê]/g, "e")
      .replace(/[íìïî]/g, "i")
      .replace(/[óòöô]/g, "o")
      .replace(/[úùüû]/g, "u");

    if (["lunesaviernes", "lunesaviernes"].includes(texto)) {
      return "LunesAviernes";
    }

    if (["sabadodomingo", "sabadoydomingo", "sabadosydomingo"].includes(texto)) {
      return "SabadoDomingo";
    }

    const diasMap = {
      lunes: "Lunes",
      martes: "Martes",
      miercoles: "Miercoles",
      jueves: "Jueves",
      viernes: "Viernes",
      sabados: "Sabados",
      domingo: "Domingo",
    };

    return diasMap[texto] || `${value}`.trim();
  };

  const normalizarBooleano = (value) => {
    if (value === true || value === 1 || value === "true" || value === "1" || value === "si" || value === "SI") {
      return true;
    }
    return false;
  };

  const getDiaActual = () => {
    const dia = new Date().getDay();
    const dias = {
      0: "Domingo",
      1: "Lunes",
      2: "Martes",
      3: "Miercoles",
      4: "Jueves",
      5: "Viernes",
      6: "Sabados",
    };
    return dias[dia] || "";
  };

  const cumpleDia = (diasConfig, diaActual) => {
    if (!diasConfig || diasConfig === "seleccione") return false;

    const valor = normalizarDia(diasConfig);
    const dia = normalizarDia(diaActual);

    if (valor === "LunesAviernes") {
      return ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes"].includes(dia);
    }

    if (valor === "SabadoDomingo") {
      return ["Sabados", "Domingo"].includes(dia);
    }

    return valor === dia;
  };

  const obtenerListaPrecioVigente = async () => {
    const sucursalId = currentU?.sucursal;
    if (!sucursalId) return "";

    let configuraciones = Array.isArray(preciosSucursal) ? preciosSucursal : [];
    if (!configuraciones.length) {
      try {
        const response =
          await PreciosSucursalService.getPreciosSucursalPorSucursal(
            sucursalId,
          );
        const data = Array.isArray(response?.precios)
          ? response.precios
          : [];
        configuraciones = data;

        setPreciosSucursal(data);
      } catch (err) {
        console.error(err);
        return "";
      }
    }

    const configuracionesSucursal = configuraciones.filter((item) => {
      const idSucursal = item?.idSucursal ?? item?.sucursal;
      return String(idSucursal) === String(sucursalId);
    });

    if (!configuracionesSucursal.length) {
      return "";
    }

    const predeterminada = configuracionesSucursal.find((item) => {
      return normalizarBooleano(item?.predCotizacion);
    });
    if (predeterminada) {
      return predeterminada.idListaPrecio || "";
    }

    const diaActual = getDiaActual();
    const horaActual = parseHora(
      new Date().toLocaleTimeString("en-GB", { hour12: false }),
    );

    // Se valida aquí si la configuración coincide con el día actual y con el rango de hora actual.
    const vigente = configuracionesSucursal.find((item) => {
      const mismoDia = cumpleDia(item?.dias, diaActual);
      if (!mismoDia) return false;

      const desde = parseHora(item?.horaInicio);
      const hasta = parseHora(item?.horaFin);
      if (desde === null || hasta === null) return false;

      return horaActual !== null && horaActual >= desde && horaActual <= hasta;
    });

    if (vigente) {
      return vigente.idListaPrecio || "";
    }

    // Si no coincide con el rango horario, se intenta usar una configuración del mismo día aunque no tenga horario definido.
    const sinHorario = configuracionesSucursal.find((item) => {
      if (!cumpleDia(item?.dias, diaActual)) return false;
      const desde = parseHora(item?.horaInicio);
      const hasta = parseHora(item?.horaFin);
      return desde === null || hasta === null;
    });

    return sinHorario?.idListaPrecio || "";
  };

  async function enrichEstudioSelection(index, selectedValue) {
    if (!selectedValue) {
      setEstudios((prev) => {
        const next = [...prev];
        next[index] = {
          ...next[index],
          idEstudio: "",
          codigo: "",
          nombre: "",
          costo: "",
          tiempoEntrega: "",
          descuento: "",
          fechaEntrega: "",
          muestras: [],
          estudiosInt: [],
        };
        return next;
      });
      return;
    }

    const id = selectedValue.idEstudio || "";
    const codigo = selectedValue.codigo || "";
    const nombre = selectedValue.nombre || "";

    let listaId = "";
    if (selectedEmpresa?.idListaPrecio) {
      listaId = selectedEmpresa.idListaPrecio;
    } else {
      listaId = await obtenerListaPrecioVigente();
    }

    if (!listaId) {
      mostrarError(
        "No existe una lista de precios vigente para la sucursal actual",
      );
      return;
    }

    const nombreL = preciosByLista?.[listaId]?.nombre ?? "Lista desconocida";
    setSelectedLista(nombreL);

    const costo =
      listaId &&
        preciosByLista[listaId] &&
        preciosByLista[listaId].precios[id] !== undefined
        ? preciosByLista[listaId].precios[id]
        : "";

    const getEstudioIntId = (estInt) =>
      String(estInt.idEstudioSec ?? estInt.idEstudio ?? estInt.idEstudioPrin ?? "");

    const existeEnOtraFila = estudios.some((e, idxItem) =>
      idxItem !== index &&
      (String(e.idEstudio) === String(id) ||
        (e.estudiosInt || []).some(
          (estInt) => getEstudioIntId(estInt) === String(id),
        )),
    );
    if (existeEnOtraFila) {
      mostrarError(
        "No se puede agregar porque este estudio ya está en la cotización o ya forma parte de un estudio integrado.",
      );
      return;
    }

    try {
      const [estudioDetalle, muestras, estudiosInt] = await Promise.all([
        EstudiosService.getEstudioPorId(id),
        MuestrasService.getMuestrasPorEstudio(id),
        EstudiosIntService.getEstudiosPorEstudio(id),
      ]);

      const estudiosIntIds = new Set(
        (estudiosInt || []).map((intEstudio) => getEstudioIntId(intEstudio)),
      );

      const yaExiste = estudios.some((e, idxItem) =>
        idxItem !== index && String(e.idEstudio) === String(id),
      );
      if (yaExiste) {
        mostrarError("El estudio ya está agregado");
        return;
      }

      const yaIncluidoComoIntegrado = estudios.some((e) =>
        (e.estudiosInt || []).some((intEstudio) =>
          getEstudioIntId(intEstudio) === String(id),
        ),
      );
      if (yaIncluidoComoIntegrado) {
        mostrarError(
          "No se puede agregar este estudio porque ya forma parte de un estudio integrado ya agregado.",
        );
        return;
      }

      const algunoIntegradoYaAgregado = estudios.some((e) =>
        String(e.idEstudio) !== String(id) &&
        estudiosIntIds.has(String(e.idEstudio)),
      );
      if (algunoIntegradoYaAgregado) {
        mostrarError(
          "No se puede agregar este estudio porque uno de sus estudios integrados ya está en la cotización.",
        );
        return;
      }

      const tiempoEntrega = estudioDetalle?.tiempoEntrega ?? "";
      const fechaEntrega = calcularFechaEntrega(tiempoEntrega);

      const muestrasConIndicaciones = (muestras || []).filter(
        (m) => m.indicacionesToma && m.indicacionesToma.trim() !== ""
      );

      if (muestrasConIndicaciones.length > 0) {
        const htmlContent = `
          <div style="text-align:left; font-size:1vw; font-family: Roboto-Regular; color: #333;">
            <p style="margin-bottom: 1.5vh; font-size: 1.1vw; font-weight: bold; color: #18234f;">
              El estudio <strong>"${nombre}"</strong> requiere las siguientes indicaciones de toma:
            </p>
            <div style="max-height: 40vh; overflow-y: auto; padding-right: 0.5vw;">
              ${muestrasConIndicaciones
            .map(
              (m) => `
                <div style="margin-bottom: 1.5vh; padding: 1vw; border-radius: 8px; border-left: 5px solid #e08505; background-color: #fcf8f2;">
                  <div style="font-weight: bold; color: #e08505; font-size: 0.95vw; margin-bottom: 0.5vh;">
                    Muestra: ${m.tipoMuestra || "No especificado"} (${m.nombreMaterial || "Material no especificado"})
                  </div>
                  <div style="font-size: 0.9vw; line-height: 1.4; color: #555;">
                    ${m.indicacionesToma}
                  </div>
                </div>
              `
            )
            .join("")}
            </div>
          </div>
        `;

        await Swal.fire({
          title: "INDICACIONES DE TOMA DE MUESTRA",
          html: htmlContent,
          icon: "warning",
          width: "50%",
          confirmButtonText: "He leído las indicaciones de toma",
          confirmButtonColor: "#2e7d32",
          allowOutsideClick: false,
          allowEscapeKey: false,
          customClass: {
            title: "tituloDegradado",
            popup: "swalMaxHeight",
          },
        });
      }

      setEstudios((prev) => {
        const next = [...prev];
        next[index] = {
          ...next[index],
          idEstudio: id,
          codigo,
          nombre,
          costo,
          descuento: "",
          tiempoEntrega,
          fechaEntrega,
          condicionesPaciente: estudioDetalle?.condicionesPaciente || "",
          indicacionesToma: estudioDetalle?.indicacionesToma || "",
          muestras: muestras || [],
          estudiosInt: estudiosInt || [],
        };

        if (index === prev.length - 1) {
          next.push({
            cantidad: "1",
            codigo: "",
            nombre: "",
            costo: "",
            idEstudio: "",
            descuento: "",
            tiempoEntrega: "",
            fechaEntrega: "",
            muestras: [],
            estudiosInt: [],
          });
        }

        return next;
      });
    } catch (err) {
      console.error(err);
    }
  }

  async function mostrarInfo(estudio) {
    Swal.fire({
      title: "DETALLE DEL ESTUDIO",
      width: "55%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
        confirmButton: "btnConfirmBlueInfo",
      },
      html: `
      <div style="text-align:left; font-size:0.9rem;">
        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">DATOS PRINCIPALES</div>
        <table border="1" style="width:50vw; margin-bottom:1em; border-collapse:collapse; text-align:left;">
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Nombre:</b></td><td>${estudio.nombre}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Tiempo de entrega:</b></td><td>${estudio.tiempoEntrega || ""} Días</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Tiempo de entrega urgente:</b></td><td>${estudio.tiempoProceso || ""} ${estudio.tiempoProcesoDH || ""}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Condiciones del paciente:</b></td><td>${estudio.condicionesPaciente || ""}</td></tr>
          <tr><td style="background-color:#172149; color:white; width:20vw;"><b>Descripción científica:</b></td><td>${estudio.descripcionCien || ""}</td></tr>
        </table>

        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">MUESTRAS DEL ESTUDIO</div>
        <table border="1" style="width:50vw; margin-bottom:1em; border-collapse:collapse; text-align:left;">
          ${estudio.muestras
          .map(
            (m) => `
            <tr><td style="background-color:#172149; color:white;><b>Tubo o Material:</b></td><td>${m.nombreMaterial}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Tipo de muestra:</b></td><td>${m.tipoMuestra}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Indicaciones para la toma:</b></td><td>${m.indicacionesToma}</td></tr>
            <tr><td style="background-color:#172149; color:white;><b>Indicaciones de estabilidad:</b></td><td>${m.indicacionesEstabilidad}</td></tr>
          `,
          )
          .join("")}
        </table>

        <div class="tituloDegradado" style="font-size:0.8vw;padding:0.5vw 0.5vw;border-radius:8px;display:block;width:100%;text-align:center;">ESTUDIOS QUE LO INTEGRAN</div>
        <ul style="margin-left:1em;">
          ${estudio.estudiosInt.map((i) => `<li><b>${i.nombre}</b></li>`).join("")}
        </ul>
      </div>
    `,
      confirmButtonText: `
    <span style="display:flex; align-items:center; gap:0.5vw;">
      Regresar
    </span>
  `,
    });
  }

  const calcularEdadDesdeFechaNacimiento = (fechaNacStr) => {
    if (!fechaNacStr) return "";
    const dateStr = String(fechaNacStr).trim().split("T")[0];
    if (!dateStr) return "";

    let birthDate;
    if (dateStr.includes("-")) {
      const parts = dateStr.split("-");
      if (parts.length === 3) {
        const [y, m, d] = parts.map(Number);
        if (y && m && d) birthDate = new Date(y, m - 1, d);
      }
    } else if (dateStr.includes("/")) {
      const parts = dateStr.split("/");
      if (parts.length === 3) {
        if (parts[0].length === 4) {
          birthDate = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
        } else {
          birthDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
        }
      }
    }

    if (!birthDate || isNaN(birthDate.getTime())) return "";

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    birthDate.setHours(0, 0, 0, 0);

    if (birthDate > today) return "";

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    if (years >= 1) {
      return `${years} AÑOS`;
    } else if (months >= 1) {
      return `${months} MESES`;
    } else if (days >= 0) {
      return `${days} DIAS`;
    }
    return "";
  };

  const normalizarEdad = (val) => {
    if (!val) return "";
    const str = String(val).trim();
    if (str === "") return "";
    if (/^\d+$/.test(str)) {
      return `${str} AÑOS`;
    }
    return str.toUpperCase().replace(/DÍAS/g, "DIAS");
  };

  const sortCotizacionesDesc = (lista) => {
    return [...(lista || [])].sort(
      (a, b) => (Number(b.idCotizacion) || 0) - (Number(a.idCotizacion) || 0)
    );
  };

  const formatFechaHoraCotizacion = (fechaInput) => {
    if (!fechaInput) return "";
    const str = String(fechaInput).trim();
    if (!str) return "";

    const match = str.match(/^(\d{4})[\/\-](\d{2})[\/\-](\d{2})(?:[\sT](\d{2}):(\d{2})(?::(\d{2}))?)?/);
    if (match) {
      const [_, yyyy, mm, dd, hh = "00", min = "00"] = match;
      return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
    }

    const d = new Date(str.includes("T") ? str : str.replace(/-/g, "/"));
    if (!isNaN(d.getTime())) {
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, "0");
      const minutes = String(d.getMinutes()).padStart(2, "0");
      return `${dd}-${mm}-${yyyy} ${hours}:${minutes}`;
    }

    return str;
  };

  async function mostrarBuscarCotizaciones() {
    let cotizacionesOriginal = [];
    let cotizacionesActivas = [];

    const resultado = await CotizacionesService.getCotizaciones();
    cotizacionesOriginal = sortCotizacionesDesc(resultado?.data?.cotizaciones);
    cotizacionesActivas = [...cotizacionesOriginal];

    const porPagina = 8;
    let paginaActual = 1;

    const construirFilas = (cotizaciones) => {
      return cotizaciones
        .map(
          (cot, idx) => {
            const nombrePacComp = [
              cot.nombrePaciente,
              cot.apPaternoPaciente || cot.apPaterno,
              cot.apMaternoPaciente || cot.apMaterno,
            ].filter(Boolean).join(" ");

            let empresaPaciente = "";
            if (cot.nombreConvenio && nombrePacComp) {
              empresaPaciente = `${cot.nombreConvenio} - ${nombrePacComp}`;
            } else if (cot.nombreConvenio) {
              empresaPaciente = cot.nombreConvenio;
            } else {
              empresaPaciente = nombrePacComp;
            }

            const fechaFormateada = formatFechaHoraCotizacion(cot.fecha);

            return `
        <tr style="background-color: ${idx % 2 === 0 ? "#ffffff" : "#f8fafc"}; border-bottom: 1px solid #e2e8f0; font-size: 0.80rem; transition: background 0.15s;">
          <td style="padding: 6px 8px; text-align: center; font-weight: 600; color: #1e293b; border-right: 1px solid #f1f5f9;">${cot.idCotizacion}</td>
          <td style="padding: 6px 10px; text-align: left; color: #334155; border-right: 1px solid #f1f5f9;">${cot.nombreSucursal || ""}</td>
          <td style="padding: 6px 8px; text-align: center; border-right: 1px solid #f1f5f9;">${cot.conversionSol === "" || cot.conversionSol === null || cot.conversionSol === undefined ? '<span style="color:#ef4444; font-weight:bold;">✘</span>' : `<span style="color:#16a34a; font-weight:bold;">${cot.conversionSol}</span>`}</td>
          <td style="padding: 6px 12px; text-align: left; font-weight: 500; color: #1e293b; border-right: 1px solid #f1f5f9;">${empresaPaciente}</td>
          <td style="padding: 6px 10px; text-align: center; color: #475569; font-size: 0.78rem; white-space: nowrap; border-right: 1px solid #f1f5f9;">${fechaFormateada}</td>
          <td style="padding: 4px 6px; text-align: center; border-right: 1px solid #f1f5f9;">
            <button data-action="mostrar" data-idcotizacion="${cot.idCotizacion}" title="Mostrar" style="background: #e0f2fe; color: #0284c7; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-eye"></i>
            </button>
          </td>
          <td style="padding: 4px 6px; text-align: center;">
            <button data-action="editar" data-idcotizacion="${cot.idCotizacion}" title="Editar" style="background: #fef3c7; color: #d97706; border: none; border-radius: 5px; width: 28px; height: 28px; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.2s; font-size: 0.85rem;">
              <i class="fas fa-edit"></i>
            </button>
          </td>
        </tr>
      `;
          }
        )
        .join("");
    };

    const renderPagina = (pagina) => {
      const inicio = (pagina - 1) * porPagina;
      const fin = inicio + porPagina;
      const paginaCotizaciones = cotizacionesActivas.slice(inicio, fin);
      const tabla = document.getElementById("tablaCotizaciones");
      if (tabla) {
        if (!paginaCotizaciones || paginaCotizaciones.length === 0) {
          tabla.innerHTML = `<tr><td colspan="7" style="padding: 24px; text-align: center; color: #64748b; font-style: italic;">No hay registros</td></tr>`;
        } else {
          tabla.innerHTML = construirFilas(paginaCotizaciones);
        }
        tabla
          .querySelectorAll("button[data-action='mostrar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idcotizacion;
              const cotizacion = cotizacionesOriginal.find(
                (item) => String(item.idCotizacion) === String(id),
              );
              if (cotizacion) {
                verCotizacion(cotizacion);
                Swal.close();
              }
            });
          });
        tabla
          .querySelectorAll("button[data-action='editar']")
          .forEach((btn) => {
            btn.addEventListener("click", () => {
              const id = btn.dataset.idcotizacion;
              const cotizacion = cotizacionesOriginal.find(
                (item) => String(item.idCotizacion) === String(id),
              );
              if (cotizacion) {
                editarCotizacion(cotizacion);
                Swal.close();
              }
            });
          });
      }

      const totalPaginas = Math.max(
        1,
        Math.ceil(cotizacionesActivas.length / porPagina),
      );
      const spanPagina = document.getElementById("paginaActual");
      if (spanPagina) {
        spanPagina.textContent = `Página ${pagina} de ${totalPaginas} (${cotizacionesActivas.length} registros)`;
      }
      const btnAnterior = document.getElementById("btnAnterior");
      const btnSiguiente = document.getElementById("btnSiguiente");
      if (btnAnterior) {
        btnAnterior.disabled = pagina <= 1;
        btnAnterior.style.opacity = pagina <= 1 ? "0.45" : "1";
        btnAnterior.style.cursor = pagina <= 1 ? "not-allowed" : "pointer";
      }
      if (btnSiguiente) {
        btnSiguiente.disabled = pagina >= totalPaginas;
        btnSiguiente.style.opacity = pagina >= totalPaginas ? "0.45" : "1";
        btnSiguiente.style.cursor = pagina >= totalPaginas ? "not-allowed" : "pointer";
      }
    };
    Swal.fire({
      title: "BUSCAR COTIZACIÓN",
      width: "65%",
      customClass: {
        title: "tituloDegradado",
        popup: "swalMaxHeight",
      },
      html: `
        <div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; text-align: left;">
          <div style="display: flex; gap: 10px; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; margin-bottom: 8px;">
            <div style="display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 200px;">
              <label for="swal-nombre" style="font-size: 0.80rem; font-weight: 600; color: #334155;">Nombre o folio de la cotización:</label>
              <input id="swal-nombre" type="text" style="padding: 5px 10px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; box-sizing: border-box;" placeholder="Escribe aquí..." />
            </div>
            <div style="display: flex; flex-direction: column; gap: 2px; min-width: 160px;">
              <label for="swal-sucursal" style="font-size: 0.80rem; font-weight: 600; color: #334155;">Sucursal:</label>
              <select id="swal-sucursal" class="swal-sucursal" style="padding: 4px 8px; border: 1px solid #cbd5e1; border-radius: 6px; font-size: 0.82rem; outline: none; height: 32px; background: white;">
                <option value="seleccione" disabled selected>Seleccione</option>
                ${sucursales
            .map(
              (sucursal) =>
                `<option value="${sucursal.idSucursal}">${sucursal.nombre}</option>`,
            )
            .join("")}
              </select>
            </div>
            <div>
              <button id="btnMostrarTodos" style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; border: none; border-radius: 6px; font-weight: 600; font-size: 0.80rem; padding: 6px 14px; cursor: pointer; box-shadow: 0 2px 4px rgba(0,0,0,0.1); height: 32px; white-space: nowrap; transition: opacity 0.2s;">
                Mostrar todas las cotizaciones
              </button>
            </div>
          </div>
  
          <div style="width: 100%; overflow: auto; max-height: 52vh; border: 1px solid #cbd5e1; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.08); background: white;">
            <table class="tablaCotizaciones" style="width: 100%; border-collapse: collapse; text-align: center;">
              <thead>
                <tr style="background: linear-gradient(180deg, #0f4b75 0%, #006787 100%); color: white; font-size: 0.80rem; position: sticky; top: 0; z-index: 2;">
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;"># Cotización</th>
                  <th style="padding: 7px 10px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Sucursal</th>
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Conversión</th>
                  <th style="padding: 7px 12px; text-align: left; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Empresa/Paciente</th>
                  <th style="padding: 7px 10px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600;">Fecha</th>
                  <th style="padding: 7px 8px; text-align: center; border-right: 1px solid rgba(255,255,255,0.15); font-weight: 600; width: 45px;">Mostrar</th>
                  <th style="padding: 7px 8px; text-align: center; font-weight: 600; width: 45px;">Editar</th>
                </tr>
              </thead>
              <tbody id="tablaCotizaciones">
              </tbody>
            </table>
          </div>

          <div style="margin-top: 8px; display: flex; justify-content: space-between; align-items: center;">
            <span id="paginaActual" style="font-size: 0.80rem; color: #64748b; font-weight: 500;"></span>
            <div style="display: flex; gap: 6px;">
              <button id="btnAnterior" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Anterior</button>
              <button id="btnSiguiente" style="padding: 4px 12px; background: #006787; color: white; border: none; border-radius: 6px; font-size: 0.80rem; font-weight: 600; cursor: pointer; transition: opacity 0.2s;">Siguiente</button>
            </div>
          </div>
        </div>
      `,
      showConfirmButton: false,
      didOpen: () => {
        renderPagina(paginaActual);

        document.getElementById("btnAnterior").addEventListener("click", () => {
          if (paginaActual > 1) {
            paginaActual--;
            renderPagina(paginaActual);
          }
        });

        document
          .getElementById("btnSiguiente")
          .addEventListener("click", () => {
            if (
              paginaActual < Math.ceil(cotizacionesActivas.length / porPagina)
            ) {
              paginaActual++;
              renderPagina(paginaActual);
            }
          });

        document
          .getElementById("btnMostrarTodos")
          .addEventListener("click", async () => {
            try {
              const resultado = await CotizacionesService.getCotizaciones();
              cotizacionesOriginal = sortCotizacionesDesc(resultado?.data?.cotizaciones);
              cotizacionesActivas = [...cotizacionesOriginal];
              paginaActual = 1;
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error al recargar cotizaciones:", error);
            }
            document.getElementById("swal-nombre").value = "";
            document.getElementById("swal-sucursal").value = "seleccione";
          });
        document
          .getElementById("swal-nombre")
          .addEventListener("input", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              cotizacionesActivas = [...cotizacionesOriginal];
              renderPagina(paginaActual);
              return;
            }

            const valLower = valor.toLowerCase();
            const filtradasLocal = cotizacionesOriginal.filter((cot) => {
              const folio = String(cot.folio || cot.codigo || cot.numero || "").toLowerCase();
              const nombrePac = `${cot.nombrePaciente || ""} ${cot.apPaternoPaciente || ""} ${cot.apMaternoPaciente || ""}`.toLowerCase();
              return folio.includes(valLower) || nombrePac.includes(valLower);
            });

            try {
              const resultado =
                await CotizacionesService.buscarCotizacionesNF(valor);
              const serverList = sortCotizacionesDesc(resultado?.cotizaciones);
              if (serverList && serverList.length > 0) {
                cotizacionesActivas = serverList;
              } else {
                cotizacionesActivas = filtradasLocal;
              }
            } catch (error) {
              console.error("Error en búsqueda:", error);
              cotizacionesActivas = filtradasLocal;
            }
            renderPagina(paginaActual);
          });
        document
          .getElementById("swal-sucursal")
          .addEventListener("change", async (e) => {
            const valor = e.target.value.trim();
            paginaActual = 1;
            if (valor === "") {
              cotizacionesActivas = [...cotizacionesOriginal];
              renderPagina(paginaActual);
              return;
            }

            try {
              const resultado =
                await CotizacionesService.buscarCotizacionesSucursal(valor);
              cotizacionesActivas = sortCotizacionesDesc(resultado?.cotizaciones);
              renderPagina(paginaActual);
            } catch (error) {
              console.error("Error en búsqueda:", error);
            }
          });
      },
    });
  }

  const handleRemoveEstudio = (index) => {
    setEstudios(estudios.filter((_, i) => i !== index));
  };

  function changeEditMode() {
    if (selectedPaciente) {
      setEditMode(true);
      setViewOnly(false);
      setViewOnlyP(false)
    }
  }

  function changePaciente() {
    setSelectedPaciente(null);
    setEditMode(false);
    setViewOnly(false);
    setViewOnlyP(false)
    setShowCotizacionPacienteHeader(false);
    setNombre("");
    setApPaterno("");
    setApMaterno("");
    setSexo("");
    setFechaNac("");
    setEdad("");
    setTelefonoCelular("");
    setDireccion("");
    setColonia("");
    setCPostal("");
    setEstado("seleccione");
    setCiudad("");
    setIne("");
    setEmail("");
  }

  async function changeEmpresa() {
    setEmpresa("");
    setViewOnlyE(false);
    let listaId = "";
    listaId = await obtenerListaPrecioVigente();
    if (!listaId) {
      mostrarError(
        "No existe una lista de precios vigente para la sucursal actual",
      );
      return;
    }
    // Actualizar el nombre de la lista en pantalla
    const nombreL = preciosByLista?.[listaId]?.nombre ?? "Lista de la sucursal";
    setSelectedLista(nombreL);

    // Recalcular costos de estudios que ya están en la tabla
    if (listaId) {
      setEstudios((prevEstudios) =>
        prevEstudios.map((estudio) => {
          if (!estudio.idEstudio) return estudio;
          const listaPreciosObj = preciosByLista[listaId];
          const nuevoCosto =
            listaPreciosObj &&
              listaPreciosObj.precios &&
              listaPreciosObj.precios[estudio.idEstudio] !== undefined
              ? listaPreciosObj.precios[estudio.idEstudio]
              : "";
          return {
            ...estudio,
            costo: nuevoCosto,
          };
        })
      );
    }
  }

  async function getPacientes() {
    const resultado = await PacientesService.getPacientes();
    setPacientes(resultado.data.pacientes);
  }
  async function getConvenios() {
    const resultado = await ConveniosService.getConvenios();
    setEmpresas(resultado.data.convenios);
  }

  async function getSucursales() {
    const resultado = await SucursalesService.getSucursales();
    setSucursales(resultado.data.sucursales);
  }
  async function fetchEstudiosOptions() {
    try {
      const res = await EstudiosService.getEstudios();
      const data = res.data.estudios || [];
      setEstudiosOptions(data);
    } catch (err) {
      console.error(err);
    }
  }

  async function fetchPrecios() {
    try {
      const resultado = await PreciosEstudioService.getPrecios();
      const data = resultado.data.precios;
      const map = {};
      (data || []).forEach((p) => {
        if (!map[p.idListaPrecio]) {
          map[p.idListaPrecio] = {
            nombre: p.nombreLista, // suponiendo que venga en el resultado
            precios: {}
          };
        }
        map[p.idListaPrecio].precios[p.idEstudio] = p.precio;
      });
      setPreciosByLista(map);
    } catch (err) {
      console.error(err);
    }
  }
  const usuarioString = sessionStorage.getItem("usuario");
  const currentU = JSON.parse(usuarioString);

  const parseNumero = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const calcularSubtotal = (items = estudios) =>
    items.reduce((acc, estudio) => {
      const cantidad = parseNumero(estudio?.cantidad || 0);
      const costo = parseNumero(estudio?.costo || 0);
      return acc + cantidad * costo;
    }, 0);

  const tieneDescuentoPorEstudio = (items = estudios) =>
    items.some((estudio) => {
      const descuento = estudio?.descuento;
      return descuento !== "" && descuento !== null && descuento !== undefined;
    });

  const calcularDescuentoTotal = (items = estudios) => {
    const usaDescuentoPorEstudio = tieneDescuentoPorEstudio(items);

    if (opcionDescuento === "porcentaje") {
      if (
        !usaDescuentoPorEstudio &&
        valorGeneral !== "" &&
        valorGeneral !== null
      ) {
        const porcentaje = parseNumero(valorGeneral);
        if (porcentaje <= 100) {
          if (porcentaje > 0) {
            return calcularSubtotal(items) * (porcentaje / 100);
          }
        } else {
          mostrarError("El porcentaje no puede ser mayor a 100%");
          setValorGeneral("");
        }
      }

      return items.reduce((acc, estudio) => {
        const porcentaje = parseNumero(estudio?.descuento || 0);
        const cantidad = parseNumero(estudio?.cantidad || 0);
        const costo = parseNumero(estudio?.costo || 0);
        return acc + cantidad * costo * (porcentaje / 100);
      }, 0);
    }

    if (opcionDescuento === "cantidad") {
      if (
        !usaDescuentoPorEstudio &&
        valorGeneral !== "" &&
        valorGeneral !== null
      ) {
        const descuento = parseNumero(valorGeneral);
        if (descuento > 0) {
          return descuento;
        }
      }

      return items.reduce((acc, estudio) => {
        const descuento = parseNumero(estudio?.descuento || 0);
        return acc + descuento;
      }, 0);
    }

    return 0;
  };

  const parseHtmlText = (htmlStr) => {
    if (!htmlStr) return "";
    let text = String(htmlStr);
    text = text.replace(/<br\s*\/?>/gi, " ");
    text = text.replace(/<\/(p|div|li|tr|h[1-6]|table|blockquote)>/gi, " ");
    text = text.replace(/<li[^>]*>/gi, " • ");
    text = text.replace(/<[^>]+>/g, "");
    text = text
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/gi, "'")
      .replace(/&ndash;/gi, "–")
      .replace(/&mdash;/gi, "—");
    return text.split(/\s+/).filter(Boolean).join(" ");
  };

  const getDeliveryDaysNum = (tiempoEntregaVal, est = null) => {
    let val = tiempoEntregaVal;
    if ((val === null || val === undefined || val === "") && est) {
      val = est.tiempoEntrega ?? est.diasProceso ?? est.tiempoProceso;
    }
    if ((val === null || val === undefined || val === "") && est?.idEstudio) {
      const opt = (estudiosOptions || []).find(o => String(o.idEstudio) === String(est.idEstudio));
      if (opt) val = opt.tiempoEntrega ?? opt.diasProceso ?? opt.tiempoProceso;
    }
    if (val === null || val === undefined || val === "") return 0;
    const s = String(val).trim().toUpperCase();
    if (s === "0" || s.includes("MISMO")) return 0;
    const match = s.match(/\d+/);
    const num = match ? parseInt(match[0], 10) : NaN;
    return !isNaN(num) ? num : 0;
  };

  const getDeliveryLabel = (tiempoEntregaVal, est = null) => {
    let val = tiempoEntregaVal;
    if ((val === null || val === undefined || val === "") && est) {
      val = est.tiempoEntrega ?? est.diasProceso ?? est.tiempoProceso;
    }
    if ((val === null || val === undefined || val === "") && est?.idEstudio) {
      const opt = (estudiosOptions || []).find(o => String(o.idEstudio) === String(est.idEstudio));
      if (opt) val = opt.tiempoEntrega ?? opt.diasProceso ?? opt.tiempoProceso;
    }
    if (val === null || val === undefined || val === "") {
      return "FECHA DE ENTREGA: EL MISMO DÍA";
    }
    const s = String(val).trim().toUpperCase();
    if (s === "0" || s === "MISMO DIA" || s === "EL MISMO DIA" || s === "MISMO DÍA" || s === "EL MISMO DÍA") {
      return "FECHA DE ENTREGA: EL MISMO DÍA";
    }
    const match = s.match(/\d+/);
    const num = match ? parseInt(match[0], 10) : NaN;
    if (!isNaN(num)) {
      if (num === 0) return "FECHA DE ENTREGA: EL MISMO DÍA";
      if (num === 1) return "FECHA DE ENTREGA: 1 DÍA";
      return `FECHA DE ENTREGA: ${num} DÍAS`;
    }
    return `FECHA DE ENTREGA: ${s}`;
  };

  const formatFechaImpresion = (fechaInput) => {
    let dateObj = new Date();
    if (fechaInput) {
      const parsed = new Date(String(fechaInput).replace(/-/g, "/"));
      if (!Number.isNaN(parsed.getTime())) {
        dateObj = parsed;
      }
    }
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const dia = String(dateObj.getDate()).padStart(2, "0");
    const mes = meses[dateObj.getMonth()];
    const anio = dateObj.getFullYear();
    const horas = String(dateObj.getHours()).padStart(2, "0");
    const minutos = String(dateObj.getMinutes()).padStart(2, "0");
    return `${dia} ${mes}, ${anio} ${horas}:${minutos} h`;
  };

  const calcularFechaEntrega = (dias) => {
    if (dias === null || dias === undefined || dias === "") return "";
    const texto = `${dias}`.trim();
    const match = texto.match(/-?\d+(?:\.\d+)?/);
    const num = match ? Number(match[0]) : Number(texto);
    if (Number.isNaN(num) || num < 0) return "";
    const fecha = new Date();
    fecha.setDate(fecha.getDate() + num);
    const yyyy = fecha.getFullYear();
    const mm = String(fecha.getMonth() + 1).padStart(2, "0");
    const dd = String(fecha.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const generarBarcode128Canvas = (texto) => {
    try {
      const canvas = document.createElement("canvas");
      canvas.width = 400;
      canvas.height = 80;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const patterns = [
        "212222", "222122", "222221", "121223", "121322", "131222", "122213", "122312", "132212", "221213",
        "221312", "231212", "112232", "122132", "122231", "113222", "123122", "123221", "223211", "221132",
        "221231", "213212", "223112", "312131", "311222", "321122", "321221", "312212", "322112", "322211",
        "212123", "212321", "232121", "111323", "131123", "131321", "112313", "132113", "132311", "211313",
        "231113", "231311", "112133", "112331", "132131", "113123", "113321", "133121", "313121", "211331",
        "231131", "213113", "213311", "213131", "311123", "311321", "331121", "312113", "312311", "332111",
        "314111", "221411", "431111", "111224", "111422", "121124", "121421", "141122", "141221", "112214",
        "112412", "122114", "122411", "142112", "142211", "241211", "221114", "413111", "241112", "134111",
        "111242", "121142", "121241", "114212", "124112", "124211", "411212", "421112", "421211", "212141",
        "214121", "412121", "111143", "111341", "131141", "114113", "114311", "411113", "411311", "113141",
        "114131", "311141", "411131", "211412", "211214", "211232", "2331112"
      ];

      const valText = String(texto || "COTIZACION").trim();
      let codeSeq = [104];
      let checksum = 104;

      for (let i = 0; i < valText.length; i++) {
        const code = valText.charCodeAt(i) - 32;
        if (code >= 0 && code <= 94) {
          codeSeq.push(code);
          checksum += code * (i + 1);
        }
      }

      const checkCode = checksum % 103;
      codeSeq.push(checkCode);
      codeSeq.push(106);

      let totalUnits = 0;
      for (let idx = 0; idx < codeSeq.length; idx++) {
        const pattern = patterns[codeSeq[idx]];
        if (!pattern) continue;
        for (let p = 0; p < pattern.length; p++) {
          totalUnits += parseInt(pattern[p], 10);
        }
      }

      const targetWidth = 370;
      const unitWidth = targetWidth / totalUnits;
      let currX = (400 - totalUnits * unitWidth) / 2;

      ctx.fillStyle = "#000000";
      for (let idx = 0; idx < codeSeq.length; idx++) {
        const pattern = patterns[codeSeq[idx]];
        if (!pattern) continue;
        for (let p = 0; p < pattern.length; p++) {
          const width = parseInt(pattern[p], 10) * unitWidth;
          if (p % 2 === 0) {
            ctx.fillRect(currX, 5, width, 70);
          }
          currX += width;
        }
      }
      return canvas.toDataURL("image/png");
    } catch (e) {
      console.error("Error generando código de barras:", e);
      return null;
    }
  };

  const generarTicketCotizacion = async (idCotTarget = null) => {
    const doc = new jsPDF({ unit: "mm", format: [75, 284], orientation: "portrait" });

    const pageWidth = 75;
    const mX = 4;
    const cW = pageWidth - mX * 2;
    const cx = pageWidth / 2;

    let sucursalActual = (sucursales || []).find(
      (s) => String(s.nombre).toLowerCase() === String(sucursalNombre || cotizacionSucursalNombre).toLowerCase()
    ) || (sucursales || [])[0] || {};

    let sucursalTelefonosStr = "";
    let horariosFormateados = [];

    if (sucursalActual.idSucursal) {
      try {
        const resTels = await TelefonosService.getTelefonosPorSucursal(sucursalActual.idSucursal);
        const listaTels = Array.isArray(resTels) ? resTels : resTels?.telefonos || [];
        sucursalTelefonosStr = listaTels.map((t) => t.telefono || t).join(", ");
      } catch (e) { }

      try {
        const resHorarios = await HorariosAtencionService.getHorariosAtencionPorSucursal(sucursalActual.idSucursal);
        const listaHorarios = Array.isArray(resHorarios) ? resHorarios : resHorarios?.horarios || [];
        const porConcepto = {};
        listaHorarios.forEach((h) => {
          const conc = h.concepto || "Laboratorio";
          if (!porConcepto[conc]) porConcepto[conc] = [];
          porConcepto[conc].push(`${h.dias || ""}: ${h.horario || ""}`);
        });
        Object.keys(porConcepto).forEach((conc) => {
          horariosFormateados.push({ titulo: `Horario de Atención de ${conc}:`, horarios: porConcepto[conc].join(", ") });
        });
      } catch (e) { }
    }

    if (horariosFormateados.length === 0) {
      horariosFormateados.push({ titulo: "Horario de Atención de Laboratorio:", horarios: "Lunes a Viernes: 8:00 a 14:00 y 17:00 a 19:00 hrs, Sábado: 8:00 a 14:00 hrs" });
    }

    const sucursalNomText = (sucursalActual.nombre || sucursalNombre || cotizacionSucursalNombre || "").toUpperCase();
    const nombreLab = (sucursalActual.nombreLaboratorio || "LABORATORIO").toUpperCase();
    const leyendaText = sucursalActual.leyenda || "";
    const calleText = [sucursalActual.calle, sucursalActual.numExterior, sucursalActual.numInterior].filter(Boolean).join(" ");
    const colCpText = `Col. ${sucursalActual.colonia || ""} C.P. ${sucursalActual.cPostal || ""} ${sucursalActual.ciudad || ""}, ${sucursalActual.estado || ""}`;
    const telText = `Tel. ${sucursalTelefonosStr || sucursalActual.telefono || ""}`;

    const nombrePacienteComp = [nombre, apPaterno, apMaterno].filter(Boolean).join(" ") || "SOLICITANTE";
    const empresaNom = selectedEmpresa?.nombre || empresa || "";
    const empNombreCompTicket = [currentU?.nombre, currentU?.apPaterno, currentU?.apMaterno].filter(Boolean).join(" ").toUpperCase() || "EMPLEADO";
    const folioCot = idCotTarget || selectedCotizacionId || cotizacionNumero || "00000000";
    const fechaStr = formatFechaImpresion(fecha || getFormattedNow());
    const barcodeImg = generarBarcode128Canvas(String(folioCot));

    let y = 4;

    try {
      const lw = 30; const lh = 18;
      doc.addImage(logoLaboratorio, "JPEG", cx - lw / 2, y, lw, lh);
      y += lh + 5;
    } catch (e) { y += 23; }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.setTextColor(0, 0, 0);
    doc.text(nombreLab, cx, y, { align: "center" });
    y += 4;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.text(sucursalNomText, cx, y, { align: "center" });
    y += 4;

    if (leyendaText) {
      doc.setFontSize(6.5);
      const leyLines = doc.splitTextToSize(leyendaText, cW);
      doc.text(leyLines, cx, y, { align: "center" });
      y += leyLines.length * 3 + 1;
    }

    y += 1;
    doc.setFillColor(24, 35, 79);
    doc.rect(mX, y, cW, 6.5, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(8.5);
    doc.text("COTIZACIÓN", cx, y + 4.3, { align: "center" });
    doc.setTextColor(0, 0, 0);
    y += 10;

    doc.setFontSize(7);
    if (calleText.trim()) {
      doc.setFont("helvetica", "bold");
      doc.text("Dirección: ", mX, y);
      const lbW = doc.getTextWidth("Dirección: ");
      doc.setFont("helvetica", "normal");
      const calleLines = doc.splitTextToSize(calleText, cW - lbW);
      doc.text(calleLines[0], mX + lbW, y);
      if (calleLines.length > 1) {
        y += 3.5;
        doc.text(doc.splitTextToSize(calleLines.slice(1).join(" "), cW), mX, y);
      }
      y += 3.5;
    }
    const colLines = doc.splitTextToSize(colCpText, cW);
    doc.setFont("helvetica", "normal");
    doc.text(colLines, mX, y);
    y += colLines.length * 3.5;
    if (telText.trim() !== "Tel.") {
      doc.text(telText, mX, y);
      y += 3.5;
    }
    y += 2;

    const infoRows = [
      ["Solicitante:", nombrePacienteComp],
    ];
    if (empresaNom) {
      infoRows.push(["Empresa:", empresaNom]);
    }
    infoRows.push(
      ["Le atendió:", empNombreCompTicket],
      ["Folio:", String(folioCot)],
      ["Fecha:", fechaStr]
    );

    const tableStartY = y;
    autoTable(doc, {
      startY: tableStartY + 1,
      margin: { left: mX + 1.5, right: mX + 1.5 },
      tableWidth: cW - 3,
      body: infoRows,
      styles: { fontSize: 7, cellPadding: 0.9, valign: "middle", textColor: [0, 0, 0] },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 22 },
        1: { cellWidth: cW - 3 - 22 },
      },
      theme: "plain",
    });

    const boxPacH = doc.lastAutoTable.finalY - tableStartY + 1;
    doc.setDrawColor(200, 220, 240);
    doc.setFillColor(245, 248, 252);
    doc.roundedRect(mX, tableStartY, cW, boxPacH, 2, 2, "FD");

    autoTable(doc, {
      startY: tableStartY + 1,
      margin: { left: mX + 1.5, right: mX + 1.5 },
      tableWidth: cW - 3,
      body: infoRows,
      styles: { fontSize: 7, cellPadding: 0.9, valign: "middle", textColor: [0, 0, 0] },
      columnStyles: {
        0: { fontStyle: "bold", cellWidth: 22 },
        1: { cellWidth: cW - 3 - 22 },
      },
      theme: "plain",
    });
    y = doc.lastAutoTable.finalY + 2;

    if (barcodeImg) {
      doc.addImage(barcodeImg, "PNG", mX, y + 2, cW, 14);
      y += 19;
    }

    const validEstudios = (estudios || []).filter(e => (e.nombre || e.codigo) && (e.idEstudio || e.nombre));
    const sortedEstudios = [...validEstudios].sort((a, b) => getDeliveryDaysNum(a.tiempoEntrega, a) - getDeliveryDaysNum(b.tiempoEntrega, b));

    const groupedMap = new Map();
    sortedEstudios.forEach(est => {
      const label = getDeliveryLabel(est.tiempoEntrega, est);
      if (!groupedMap.has(label)) {
        groupedMap.set(label, []);
      }
      groupedMap.get(label).push(est);
    });

    const rowsTicket = [];
    let consecutivo = 1;

    groupedMap.forEach((estudiosGrupo, labelGrupo) => {
      rowsTicket.push([
        {
          content: labelGrupo,
          colSpan: 4,
          styles: {
            fillColor: [0, 0, 0],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 7,
            halign: "left",
            cellPadding: 1,
          },
          _isGroupHeader: true,
        }
      ]);

      estudiosGrupo.forEach((est) => {
        const cant = parseNumero(est.cantidad || 1);
        const cost = parseNumero(est.costo || 0);
        const lineTotal = cant * cost;

        let rawIndText = est.condicionesPaciente || est.indicacionesToma || "";
        if (!rawIndText && est.idEstudio) {
          const opt = (estudiosOptions || []).find(o => String(o.idEstudio) === String(est.idEstudio));
          if (opt) {
            rawIndText = opt.condicionesPaciente || opt.indicacionesToma || "";
          }
        }
        if (!rawIndText && Array.isArray(est.muestras) && est.muestras.length > 0) {
          const mConInd = est.muestras.find(m => m.indicacionesToma && m.indicacionesToma.trim());
          if (mConInd) rawIndText = mConInd.indicacionesToma;
        }
        const cleanIndText = parseHtmlText(rawIndText);

        rowsTicket.push([
          String(consecutivo),
          String(cant),
          {
            content: (est.nombre || "").toUpperCase(),
            _indicaciones: cleanIndText,
          },
          `$ ${lineTotal.toFixed(2)}`
        ]);
        consecutivo++;
      });
    });

    autoTable(doc, {
      startY: y,
      margin: { left: mX, right: mX },
      tableWidth: cW,
      head: [
        [
          { content: "No.", styles: { halign: "center", cellWidth: 6 } },
          { content: "Cant.", styles: { halign: "center", cellWidth: 8 } },
          { content: "Estudio", styles: { halign: "left", cellWidth: cW - 6 - 8 - 18 } },
          { content: "Total", styles: { halign: "right", cellWidth: 18 } },
        ],
      ],
      body: rowsTicket,
      styles: { fontSize: 6.8, cellPadding: 1, valign: "top", textColor: [0, 0, 0] },
      headStyles: { fillColor: [210, 228, 243], textColor: [24, 35, 79], fontStyle: "bold", fontSize: 7 },
      columnStyles: {
        0: { halign: "center" },
        1: { halign: "center" },
        2: { halign: "left" },
        3: { halign: "right" },
      },
      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 2 && !data.row.raw[0]?._isGroupHeader) {
          const raw = data.row.raw;
          const ind = raw[2]?._indicaciones;
          if (ind) {
            data.cell._customIndicaciones = true;
            data.cell._nomEst = raw[2].content;
            data.cell._ind = ind;

            doc.setFontSize(6);
            doc.setFont("helvetica", "normal");
            const availW = data.cell.width - data.cell.padding("left") - data.cell.padding("right");
            const splitInd = doc.splitTextToSize(`Indicaciones: ${ind}`, Math.max(10, availW));
            data.cell.text = [raw[2].content, ...splitInd];
          }
        }
      },
      willDrawCell: (data) => {
        if (data.section === "body" && data.column.index === 2 && data.cell._customIndicaciones) {
          const x = data.cell.x + data.cell.padding("left");
          let y0 = data.cell.y + data.cell.padding("top") + 2.5;
          doc.setFontSize(6.8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(data.cell._nomEst, x, y0);

          y0 += 3.2;
          doc.setFontSize(6);
          doc.setFont("helvetica", "bold");
          doc.setTextColor(24, 35, 79);
          doc.text("Indicaciones: ", x, y0);
          const lblW = doc.getTextWidth("Indicaciones: ");
          doc.setFont("helvetica", "normal");
          doc.setTextColor(50, 50, 50);
          const maxW = data.cell.width - data.cell.padding("left") - data.cell.padding("right");
          const splitInd = doc.splitTextToSize(data.cell._ind, Math.max(10, maxW - lblW));
          doc.text(splitInd, x + lblW, y0);
          return false;
        }
      },
    });
    y = doc.lastAutoTable.finalY + 3;

    doc.setFontSize(7.5);
    const subtot = calcularSubtotal(validEstudios);
    const descVal = calcularDescuentoTotal(validEstudios);
    const totFinal = Math.max(0, subtot - descVal);
    const totX = mX + cW;

    doc.setFont("helvetica", "normal");
    doc.text("Subtotal:", mX + cW * 0.45, y);
    doc.text(`$ ${subtot.toFixed(2)}`, totX, y, { align: "right" });
    y += 4;

    if (descVal > 0) {
      doc.setFont("helvetica", "normal");
      doc.text("Descuento:", mX + cW * 0.45, y);
      doc.text(`$ ${descVal.toFixed(2)}`, totX, y, { align: "right" });
      y += 4;
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(8);
    doc.text("Total:", mX + cW * 0.45, y);
    doc.text(`$ ${totFinal.toFixed(2)}`, totX, y, { align: "right" });
    y += 6;

    horariosFormateados.forEach(hf => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6.5);
      doc.setTextColor(24, 35, 79);
      doc.text(hf.titulo, mX, y);
      y += 3.2;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.setTextColor(50, 50, 50);
      const splitH = doc.splitTextToSize(hf.horarios, cW);
      doc.text(splitH, mX, y);
      y += splitH.length * 3 + 2;
    });

    const nombreArchivo = `ticketCotizacion-${folioCot}.pdf`;
    doc.setProperties({ title: nombreArchivo });
    return { blob: doc.output("blob", { filename: nombreArchivo }), nombre: nombreArchivo };
  };

  const generarPDFCotizacion = async (idCotTarget = null) => {
    const doc = new jsPDF();
    const pW = 210;
    const mX = 14;
    const cW = pW - mX * 2; // 182mm

    let sucursalActual = (sucursales || []).find(
      (s) => String(s.nombre).toLowerCase() === String(sucursalNombre || cotizacionSucursalNombre).toLowerCase()
    ) || (sucursales || [])[0] || {};

    let sucursalTelefonosStr = "";
    let horariosFormateados = [];

    if (sucursalActual.idSucursal) {
      try {
        const resTels = await TelefonosService.getTelefonosPorSucursal(sucursalActual.idSucursal);
        const listaTels = Array.isArray(resTels) ? resTels : resTels?.telefonos || [];
        sucursalTelefonosStr = listaTels.map((t) => t.telefono || t).join(", ");
      } catch (e) { }

      try {
        const resHorarios = await HorariosAtencionService.getHorariosAtencionPorSucursal(sucursalActual.idSucursal);
        const listaHorarios = Array.isArray(resHorarios) ? resHorarios : resHorarios?.horarios || [];
        const porConcepto = {};
        listaHorarios.forEach((h) => {
          const conc = h.concepto || "Laboratorio";
          if (!porConcepto[conc]) porConcepto[conc] = [];
          porConcepto[conc].push(`${h.dias || ""}: ${h.horario || ""}`);
        });
        Object.keys(porConcepto).forEach((conc) => {
          horariosFormateados.push({ titulo: `Horario de Atención de ${conc}:`, horarios: porConcepto[conc].join(", ") });
        });
      } catch (e) { }
    }

    if (horariosFormateados.length === 0) {
      horariosFormateados.push({ titulo: "Horario de Atención de Laboratorio:", horarios: "Lunes a Viernes: 8:00 a 14:00 y 17:00 a 19:00 hrs, Sábado: 8:00 a 14:00 hrs" });
    }

    const sucursalNomText = (sucursalActual.nombre || sucursalNombre || cotizacionSucursalNombre || "").toUpperCase();
    const nombreLab = (sucursalActual.nombreLaboratorio || "LABORATORIO").toUpperCase();
    const calleText = [sucursalActual.calle, sucursalActual.numExterior, sucursalActual.numInterior].filter(Boolean).join(" ");
    const colCpText = `Col. ${sucursalActual.colonia || ""} C.P. ${sucursalActual.cPostal || ""} ${sucursalActual.ciudad || ""}, ${sucursalActual.estado || ""}`;
    const telText = `Tel. ${sucursalTelefonosStr || sucursalActual.telefono || ""}`;

    const nombrePacienteComp = [nombre, apPaterno, apMaterno].filter(Boolean).join(" ") || "SOLICITANTE";
    const empresaNom = selectedEmpresa?.nombre || empresa || "";
    const empNombreCompTicket = [currentU?.nombre, currentU?.apPaterno, currentU?.apMaterno].filter(Boolean).join(" ").toUpperCase() || "EMPLEADO";
    const folioCot = idCotTarget || selectedCotizacionId || cotizacionNumero || "00000000";
    const fechaStr = formatFechaImpresion(fecha || getFormattedNow());
    const barcodeImg = generarBarcode128Canvas(String(folioCot));

    const startY = 8;
    try {
      doc.addImage(logoLaboratorio, "JPEG", 14, startY, 45, 30);
    } catch (e) { }

    doc.setFillColor(24, 35, 79);
    doc.rect(115, startY, 81, 7, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("COTIZACIÓN", 155.5, startY + 5, { align: "center" });

    doc.setTextColor(0, 0, 0);
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");
    doc.text(sucursalNomText, 196, startY + 11, { align: "right" });

    let currY = startY + 15;
    if (calleText.trim()) {
      doc.setFont("helvetica", "bold");
      const labelDir = "Dirección: ";
      const lbW = doc.getTextWidth(labelDir);
      const dirStartX = 196 - (doc.getTextWidth(`${labelDir}${calleText}`));
      doc.text(labelDir, dirStartX, currY);
      doc.setFont("helvetica", "normal");
      doc.text(calleText, dirStartX + lbW, currY);
      currY += 4;
    }
    doc.setFont("helvetica", "normal");
    doc.text(colCpText, 196, currY, { align: "right" });
    currY += 4;
    if (telText.trim() !== "Tel.") {
      doc.text(telText, 196, currY, { align: "right" });
      currY += 4;
    }

    const boxY = Math.max(startY + 32, currY + 1);
    const boxH = empresaNom ? 27 : 22;
    doc.setDrawColor(200, 220, 240);
    doc.setFillColor(245, 248, 252);
    doc.roundedRect(14, boxY, 125, boxH, 2, 2, "FD");

    let lineY = boxY + 6;
    if (empresaNom) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9.5);
      doc.text("Empresa:", 17, lineY);
      doc.setFont("helvetica", "normal");
      doc.text(empresaNom.toUpperCase(), 37, lineY);
      lineY += 5.5;
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(9.5);
    doc.text("Solicitante:", 17, lineY);
    doc.setFont("helvetica", "normal");
    doc.text(nombrePacienteComp.toUpperCase(), 37, lineY);
    lineY += 5.5;

    doc.setFont("helvetica", "bold");
    doc.text("Lo atendió:", 17, lineY);
    doc.setFont("helvetica", "normal");
    doc.text(empNombreCompTicket, 37, lineY);
    lineY += 5.5;

    doc.setFont("helvetica", "bold");
    doc.text("Fecha:", 17, lineY);
    doc.setFont("helvetica", "normal");
    doc.text(fechaStr, 37, lineY);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text(`Folio: ${folioCot}`, 169, boxY + 6, { align: "center" });

    if (barcodeImg) {
      doc.addImage(barcodeImg, "PNG", 140, boxY + 9, 56, 11);
    }

    const validEstudios = (estudios || []).filter(e => (e.nombre || e.codigo) && (e.idEstudio || e.nombre));
    const sortedEstudios = [...validEstudios].sort((a, b) => getDeliveryDaysNum(a.tiempoEntrega, a) - getDeliveryDaysNum(b.tiempoEntrega, b));

    const groupedMap = new Map();
    sortedEstudios.forEach(est => {
      const label = getDeliveryLabel(est.tiempoEntrega, est);
      if (!groupedMap.has(label)) {
        groupedMap.set(label, []);
      }
      groupedMap.get(label).push(est);
    });

    const rowsTable = [];
    let consecutivo = 1;

    groupedMap.forEach((estudiosGrupo, labelGrupo) => {
      rowsTable.push([
        {
          content: labelGrupo,
          colSpan: 4,
          styles: {
            fillColor: [0, 0, 0],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            fontSize: 8.5,
            halign: "left",
            cellPadding: 1.5,
          },
          _isGroupHeader: true,
        }
      ]);

      estudiosGrupo.forEach((est) => {
        const cant = parseNumero(est.cantidad || 1);
        const cost = parseNumero(est.costo || 0);
        const lineTotal = cant * cost;

        let rawIndText = est.condicionesPaciente || est.indicacionesToma || "";
        if (!rawIndText && est.idEstudio) {
          const opt = (estudiosOptions || []).find(o => String(o.idEstudio) === String(est.idEstudio));
          if (opt) {
            rawIndText = opt.condicionesPaciente || opt.indicacionesToma || "";
          }
        }
        if (!rawIndText && Array.isArray(est.muestras) && est.muestras.length > 0) {
          const mConInd = est.muestras.find(m => m.indicacionesToma && m.indicacionesToma.trim());
          if (mConInd) rawIndText = mConInd.indicacionesToma;
        }
        const cleanIndText = parseHtmlText(rawIndText);

        rowsTable.push([
          String(consecutivo),
          String(cant),
          {
            content: (est.nombre || "").toUpperCase(),
            _indicaciones: cleanIndText,
          },
          { content: `$ ${lineTotal.toFixed(2)}`, styles: { halign: "right" } },
        ]);
        consecutivo++;
      });
    });

    autoTable(doc, {
      startY: boxY + boxH + 4,
      tableWidth: 182,
      margin: { left: 14 },
      head: [
        [
          { content: "NO.", styles: { halign: "center", cellWidth: 12 } },
          { content: "CANTIDAD", styles: { halign: "center", cellWidth: 20 } },
          { content: "ESTUDIO", styles: { halign: "left", cellWidth: 120 } },
          { content: "TOTAL", styles: { halign: "right", cellWidth: 30 } },
        ],
      ],
      body: rowsTable,
      styles: { fontSize: 8.5, cellPadding: 1.5, valign: "top", textColor: [0, 0, 0] },
      headStyles: { fillColor: [210, 228, 243], textColor: [24, 35, 79], fontStyle: "bold", fontSize: 9 },
      columnStyles: {
        0: { halign: "center" },
        1: { halign: "center" },
        2: { halign: "left" },
        3: { halign: "right" },
      },
      didParseCell: (data) => {
        if (data.section === "body" && data.column.index === 2 && !data.row.raw[0]?._isGroupHeader) {
          const raw = data.row.raw;
          const ind = raw[2]?._indicaciones;
          if (ind) {
            data.cell._customIndicaciones = true;
            data.cell._nomEst = raw[2].content;
            data.cell._ind = ind;

            doc.setFontSize(7.5);
            doc.setFont("helvetica", "normal");
            const availW = data.cell.width - data.cell.padding("left") - data.cell.padding("right");
            const splitInd = doc.splitTextToSize(`Indicaciones: ${ind}`, Math.max(10, availW));
            data.cell.text = [raw[2].content, ...splitInd];
          }
        }
      },
      willDrawCell: (data) => {
        if (data.section === "body" && data.column.index === 2 && data.cell._customIndicaciones) {
          const x = data.cell.x + data.cell.padding("left");
          let y0 = data.cell.y + data.cell.padding("top") + 3;
          doc.setFontSize(8.5);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(0, 0, 0);
          doc.text(data.cell._nomEst, x, y0);

          y0 += 4;
          doc.setFont("helvetica", "bold");
          doc.setFontSize(7.5);
          doc.setTextColor(24, 35, 79);
          doc.text("Indicaciones: ", x, y0);
          const lblW = doc.getTextWidth("Indicaciones: ");
          doc.setFont("helvetica", "normal");
          doc.setTextColor(50, 50, 50);
          const maxW = data.cell.width - data.cell.padding("left") - data.cell.padding("right");
          const splitInd = doc.splitTextToSize(data.cell._ind, Math.max(10, maxW - lblW));
          doc.text(splitInd, x + lblW, y0);
          return false;
        }
      },
    });

    let totY = doc.lastAutoTable.finalY + 4;
    const subtot = calcularSubtotal(validEstudios);
    const descVal = calcularDescuentoTotal(validEstudios);
    const totFinal = Math.max(0, subtot - descVal);

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Subtotal:", 145, totY);
    doc.text(`$ ${subtot.toFixed(2)}`, 196, totY, { align: "right" });
    totY += 4.5;

    if (descVal > 0) {
      doc.text("Descuento:", 145, totY);
      doc.text(`$ ${descVal.toFixed(2)}`, 196, totY, { align: "right" });
      totY += 4.5;
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Total:", 145, totY);
    doc.text(`$ ${totFinal.toFixed(2)}`, 196, totY, { align: "right" });
    totY += 8;

    horariosFormateados.forEach(hf => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.setTextColor(24, 35, 79);
      doc.text(hf.titulo, 14, totY);
      totY += 3.5;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(7.5);
      doc.setTextColor(50, 50, 50);
      const splitH = doc.splitTextToSize(hf.horarios, 182);
      doc.text(splitH, 14, totY);
      totY += splitH.length * 3.5 + 2;
    });

    const nombreArchivo = `cotizacion-${folioCot}.pdf`;
    doc.setProperties({ title: nombreArchivo });
    return doc.output("blob", { filename: nombreArchivo });
  };

  const mostrarPDFCotizacion = async (idCotTarget = null) => {
    try {
      await ejecutarConCargandoPDF(
        async () => {
          const targetId = idCotTarget || selectedCotizacionId || cotizacionNumero;
          const [blobCotizacion, resultTicket] = await Promise.all([
            generarPDFCotizacion(targetId),
            generarTicketCotizacion(targetId),
          ]);

          const urlCotizacion = URL.createObjectURL(new Blob([blobCotizacion], { type: "application/pdf" }));
          const urlTicket = URL.createObjectURL(new Blob([resultTicket.blob], { type: "application/pdf" }));

          const folioStr = String(targetId || "00000000");
          const pdfIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:6px;"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>`;

          Swal.fire({
            title: "Cotización Generada",
            html: `
              <div style="display:flex;align-items:center;justify-content:flex-end;margin-bottom:8px;">
                <button id="btn-descargar-cotizacion-pdfs" style="
                  display:inline-flex;align-items:center;
                  background:#28a745;color:#fff;border:none;border-radius:6px;
                  padding:8px 18px;font-size:14px;font-weight:600;
                  cursor:pointer;box-shadow:0 2px 6px rgba(40,167,69,0.3);
                  transition:background 0.2s;
                " onmouseover="this.style.background='#218838'" onmouseout="this.style.background='#28a745'">
                  ${pdfIconSvg} Descargar PDFs
                </button>
              </div>
              <div style="display:flex;gap:10px;height:560px;">
                <div style="flex:1;display:flex;flex-direction:column;min-width:0;">
                  <p style="margin:0 0 3px;font-weight:600;font-size:12px;">Cotización (A4)</p>
                  <iframe src="${urlCotizacion}" style="flex:1;border:none;border-radius:6px;width:100%;"></iframe>
                </div>
                <div style="flex:1;display:flex;flex-direction:column;min-width:0;">
                  <p style="margin:0 0 3px;font-weight:600;font-size:12px;">Ticket de Cotización</p>
                  <iframe src="${urlTicket}" style="flex:1;border:none;border-radius:6px;width:100%;"></iframe>
                </div>
              </div>`,
            width: "90%",
            showCloseButton: true,
            showConfirmButton: false,
            didOpen: () => {
              const btnDescargar = document.getElementById("btn-descargar-cotizacion-pdfs");
              if (btnDescargar) {
                btnDescargar.addEventListener("click", () => {
                  const descargar = (blob, nombre) => {
                    const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = nombre;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                  };
                  descargar(blobCotizacion, `cotizacion-${folioStr}.pdf`);
                  setTimeout(() => descargar(resultTicket.blob, resultTicket.nombre), 300);
                });
              }
            },
          });
        },
        "Generando cotización y ticket...",
        "Procesando documentos"
      );
    } catch (error) {
      console.error("Error al generar vista previa de PDFs de cotización:", error);
      mostrarError("No se pudo generar la vista previa de los PDFs.");
    }
  };
  const handleEnviarTicketWhatsAppCotizacion = async () => {
    const targetId = selectedCotizacionId || cotizacionNumero || "0";
    const telefonoInicial = telefonoCelular || "";

    const { value: telInput } = await Swal.fire({
      title: "Enviar Cotización por WhatsApp",
      text: "Ingresa el número telefónico al cual deseas enviar la cotización:",
      input: "text",
      inputValue: telefonoInicial,
      inputPlaceholder: "Ej. 5512345678",
      showCancelButton: true,
      confirmButtonText: "Enviar a WhatsApp",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#25D366",
      cancelButtonColor: "#d33",
      inputValidator: (val) => {
        if (!val || !val.trim()) return "Debes ingresar un número telefónico";
        const numLimpio = val.replace(/\D/g, "");
        if (numLimpio.length > 10) return "El número de teléfono no puede tener más de 10 dígitos";
        if (numLimpio.length < 10) return "Ingresa un número válido de 10 dígitos";
      },
    });

    if (!telInput) return;

    try {
      Swal.fire({
        title: "Generando enlace...",
        text: "Por favor espere un momento",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const resultTicket = await generarTicketCotizacion(targetId);
      if (!resultTicket || !resultTicket.blob) {
        mostrarError("No se pudo generar el ticket de cotización.");
        return;
      }

      const formData = new FormData();
      formData.append("ticketPdf", resultTicket.blob, `cotizacion_${targetId}.pdf`);
      formData.append("idSolicitud", targetId);

      let linkDownload = "";
      try {
        const resp = await SolicitudesService.uploadTicketWhatsApp(formData, targetId);
        linkDownload = resp?.data?.linkDownload || `http://localhost:4000/solicitudes/ticket/public/${resp?.data?.token || targetId}`;
      } catch (errUp) {
        console.warn("Error backend subiendo ticket cotización:", errUp);
        linkDownload = `http://localhost:4000/solicitudes/ticket/public/${targetId}`;
      }

      let numLimpio = telInput.replace(/\D/g, "");
      if (numLimpio.length === 10) numLimpio = `521${numLimpio}`;

      const mensaje = `Laboratorios García ha enviado su cotización para visualizarlo de clic en el siguiente link : ${linkDownload}`;
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${numLimpio}&text=${encodeURIComponent(mensaje)}`;
      window.open(whatsappUrl, "_blank");

      mostrarToast("Se abrió WhatsApp con la cotización", "success");
    } catch (errW) {
      console.error("Error al enviar cotización por WhatsApp:", errW);
      mostrarError("Ocurrió un error al procesar el envío por WhatsApp.");
    }
  };

  const handleEnviarCorreoCotizacion = async () => {
    const targetId = selectedCotizacionId || cotizacionNumero || "0";
    const emailInicial = email || "";

    const { value: emailInput } = await Swal.fire({
      title: "Enviar Cotización por Correo Electrónico",
      text: "Ingresa el correo electrónico al cual deseas enviar la cotización:",
      input: "email",
      inputValue: emailInicial,
      inputPlaceholder: "ejemplo@correo.com",
      showCancelButton: true,
      confirmButtonText: "Enviar Correo",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ffb300",
      cancelButtonColor: "#d33",
      inputValidator: (val) => {
        if (!val || !val.includes("@")) return "Ingresa un correo electrónico válido";
      },
    });

    if (!emailInput) return;

    try {
      Swal.fire({
        title: "Enviando correo...",
        text: "Por favor espere un momento",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const blobCotizacion = await generarPDFCotizacion(targetId);
      if (!blobCotizacion) {
        mostrarError("No se pudo generar la cotización PDF.");
        return;
      }

      const formData = new FormData();
      formData.append("pdf", blobCotizacion, `cotizacion_${targetId}.pdf`);
      formData.append("idSolicitud", targetId);
      formData.append("codigoSolicitud", targetId);
      formData.append("tipoDocumento", "Cotización");
      formData.append("esCotizacion", "true");
      formData.append("email", emailInput.trim());

      let resp;
      try {
        resp = await SolicitudesService.enviarCorreoInforme(formData);
      } catch (errC) {
        console.warn("Error backend enviando correo cotización:", errC);
        resp = { data: { estatus: "ERROR", mensaje: errC?.response?.data?.mensaje || "Servidor no disponible" } };
      }

      if (resp?.data?.estatus === "OK") {
        mostrarToast(`Cotización enviada con éxito a ${emailInput.trim()}`, "success");
      } else {
        mostrarError(resp?.data?.mensaje || "No se pudo enviar el correo de cotización.");
      }
    } catch (errE) {
      console.error("Error al enviar cotización por correo:", errE);
      mostrarError("Ocurrió un error al enviar el correo electrónico.");
    }
  };



  const totalCotizacion = calcularSubtotal();
  const descuentoTotal = calcularDescuentoTotal();
  const netoCotizacion = totalCotizacion - descuentoTotal;
  const porcentajeEquivalente =
    opcionDescuento === "porcentaje" && totalCotizacion > 0
      ? ((descuentoTotal / totalCotizacion) * 100).toFixed(2)
      : "";
  const valorGeneralMostrado =
    opcionDescuento === "ninguno"
      ? ""
      : tieneDescuentoPorEstudio()
        ? porcentajeEquivalente
        : valorGeneral;

  const validarDescuentosFormulario = (
    opcionDesc = opcionDescuento,
    valGen = valorGeneral,
    listaEstudios = estudios
  ) => {
    if (opcionDesc === "ninguno") {
      return { esValido: true, errorGeneral: "", erroresEstudios: new Array(listaEstudios.length).fill("") };
    }

    const subtotalBruto = calcularSubtotal(listaEstudios);
    let errGeneral = "";
    const errEstudios = new Array(listaEstudios.length).fill("");

    if (opcionDesc === "porcentaje") {
      if (valGen !== "" && valGen !== null && valGen !== undefined) {
        const pctVal = parseNumero(valGen);
        if (pctVal > 100) {
          errGeneral = "El descuento en porcentaje no puede ser mayor a 100%.";
        }
      }

      listaEstudios.forEach((est, idx) => {
        if (est?.descuento !== "" && est?.descuento !== null && est?.descuento !== undefined) {
          const pctEst = parseNumero(est.descuento);
          if (pctEst > 100) {
            errEstudios[idx] = "El descuento en porcentaje no puede ser mayor a 100%.";
          }
        }
      });
    } else if (opcionDesc === "cantidad") {
      if (valGen !== "" && valGen !== null && valGen !== undefined) {
        const montoVal = parseNumero(valGen);
        if (montoVal > subtotalBruto) {
          errGeneral = "El descuento no puede ser mayor al total de la cotización.";
        }
      }

      listaEstudios.forEach((est, idx) => {
        if (est?.descuento !== "" && est?.descuento !== null && est?.descuento !== undefined) {
          const montoEst = parseNumero(est.descuento);
          const costoEst = parseNumero(est.costo) * parseNumero(est.cantidad || 1);
          if (montoEst > costoEst) {
            errEstudios[idx] = "El descuento no puede ser mayor al total del estudio.";
          }
        }
      });
    }

    return {
      esValido: !errGeneral && !errEstudios.some(Boolean),
      errorGeneral: errGeneral,
      erroresEstudios: errEstudios,
    };
  };

  useEffect(() => {
    const resVal = validarDescuentosFormulario(opcionDescuento, valorGeneral, estudios);
    setErrorDescuentoGeneral(resVal.errorGeneral);
    setErroresDescuentoEstudios(resVal.erroresEstudios);
  }, [opcionDescuento, valorGeneral, estudios]);

  const handleChangeEstudio = (index, field, value) => {
    if (opcionDescuento === "porcentaje" && field === "descuento" && parseNumero(value) > 100) {
      mostrarError("El descuento en porcentaje no puede ser mayor a 100%.");
    }

    const nuevosEstudios = [...estudios];
    const estudioAnterior = estudios[index] || {};
    nuevosEstudios[index] = {
      ...estudioAnterior,
      [field]: value,
    };
    setEstudios(nuevosEstudios);

    if (field === "descuento" && opcionDescuento !== "ninguno") {
      if (opcionDescuento === "porcentaje") {
        const tieneDescuento = nuevosEstudios.some(
          (estudio) => estudio.descuento !== "" && estudio.descuento !== null,
        );
        if (tieneDescuento) {
          const subtotal = calcularSubtotal(nuevosEstudios);
          const totalDescuento = calcularDescuentoTotal(nuevosEstudios);
          const porcentajeEquivalente =
            subtotal > 0 ? ((totalDescuento / subtotal) * 100).toFixed(2) : "";
          setValorGeneral(porcentajeEquivalente);
        } else {
          setValorGeneral("");
        }
      } else if (opcionDescuento === "cantidad") {
        setValorGeneral("");
      }
    }
  };

  const handleChangeValorGeneral = (value) => {
    setValorGeneral(value);

    if (opcionDescuento === "ninguno" || value === "" || value === null) {
      return;
    }

    setEstudios((prev) =>
      prev.map((estudio) => ({
        ...estudio,
        descuento: "",
      })),
    );
  };

  const handleChangeOpcionDescuento = (value) => {
    setOpcionDescuento(value);
    setValorGeneral("");
    setEstudios((prev) =>
      prev.map((estudio) => ({
        ...estudio,
        descuento: "",
      })),
    );
  };

  const verCotizacion = async (cotizacion) => {
    const datosHeader = {
      idCotizacion: cotizacion?.idCotizacion || null,
      fecha: cotizacion?.fecha || "",
      nombreInserto: cotizacion?.nombreInserto + " " + cotizacion?.apPaternoInserto + " " + cotizacion?.apMaternoInserto || cotizacion?.inserto || "",
      nombreSucursal:
        cotizacion?.nombreSucursal ||
        cotizacion?.sucursalNombre ||
        cotizacion?.sucursal ||
        "",
    };

    setSelectedCotizacionId(datosHeader.idCotizacion);
    setCotizacionNumero(datosHeader.idCotizacion || "");
    setCotizacionFecha(datosHeader.fecha);
    setCotizacionInserto(datosHeader.nombreInserto);
    setSucursalNombre(datosHeader.nombreSucursal);
    setFecha(datosHeader.fecha);
    setShowCotizacionPacienteHeader(true);

    try {
      let resultado;
      if (cotizacion.idConvenio) {
        resultado = await ConveniosService.getConvenioPorId(
          cotizacion.idConvenio,
        );
        let empresaCompleta = resultado.convenio[0];
        setEmpresa(empresaCompleta.nombre);
        setSelectedEmpresa(empresaCompleta);
      }
      if (cotizacion.idPaciente) {
        resultado = await PacientesService.getPacientePorId(
          cotizacion.idPaciente,
        );
        let pacienteCompleto = resultado.paciente;
        setSelectedPaciente(pacienteCompleto[0]);
        setNombre(pacienteCompleto[0].nombre);
        setApPaterno(pacienteCompleto[0].apPaterno);
        setApMaterno(pacienteCompleto[0].apMaterno);
        setSexo(pacienteCompleto[0].sexo);
        setFechaNac(pacienteCompleto[0].fechaNacimiento);
        setEdad(pacienteCompleto[0].edad);
        setEmail(pacienteCompleto[0].email);
        setTelefonoCelular(pacienteCompleto[0].telefonoCelular);
        setDireccion(pacienteCompleto[0].direccion);
        setColonia(pacienteCompleto[0].colonia);
        setCPostal(pacienteCompleto[0].cPostal);
        setEstado(pacienteCompleto[0].estado);
        setCiudad(pacienteCompleto[0].ciudad);
        setIne(pacienteCompleto[0].ine);
      }
      resultado = await CotizacionesEstudiosService.getEstudiosPorCotizacion(
        cotizacion.idCotizacion,
      );
      let estudiosCompleto = resultado.estudios;
      const estudiosConDetalles = await Promise.all(
        estudiosCompleto.map(async (estudio) => {
          const estudioPorId = await EstudiosService.getEstudioPorId(
            estudio.idEstudio,
          );
          const [muestras, estudiosInt] = await Promise.all([
            MuestrasService.getMuestrasPorEstudio(estudio.idEstudio),
            EstudiosIntService.getEstudiosPorEstudio(estudio.idEstudio),
          ]);

          return {
            ...estudio,
            codigo: estudioPorId?.codigo || "",
            nombre: estudioPorId?.nombre || "",
            tiempoEntrega: estudioPorId?.tiempoEntrega ?? "",
            condicionesPaciente: estudioPorId?.condicionesPaciente || "",
            indicacionesToma: estudioPorId?.indicacionesToma || "",
            muestras: muestras || [],
            estudiosInt: estudiosInt || [],
          };
        }),
      );
      setEstudios(estudiosConDetalles);
      setObservaciones(cotizacion.observaciones);
      setValorGeneral(cotizacion.descuentoTotal);
      setSelectedCotizacionId(cotizacion.idCotizacion || null);
      setCotizacionNumero(cotizacion.idCotizacion || "");
      setCotizacionFecha(cotizacion.fecha || "");
      setCotizacionInserto(cotizacion.nombreInserto || "");
      setSucursalNombre(cotizacion.nombreSucursal || "");
      setFecha(cotizacion.fecha || "");
      setOpcionDescuento(cotizacion.tipoDescuento || "");
      try {
        const suc = await SucursalesService.getSucursalIndividual(cotizacion.idSucursal);
        setCotizacionSucursalNombre(suc?.nombre || "");

      } catch (err) {
        console.error("Error fetching sucursal:", err);
      }
    } catch (error) {
      console.error(error);
    }
    setEditMode(false);
    setViewOnlyE(false);
    setViewOnlyP(false);
    setEditModeG(false);
    setViewOnly(true);
  };

  const editarCotizacion = async (cotizacion) => {
    const datosHeader = {
      idCotizacion: cotizacion?.idCotizacion || null,
      fecha: cotizacion?.fecha || "",
      nombreInserto: cotizacion?.nombreInserto || cotizacion?.inserto || "",
      nombreSucursal:
        cotizacion?.nombreSucursal ||
        cotizacion?.sucursalNombre ||
        cotizacion?.sucursal ||
        "",
    };

    setSelectedCotizacionId(datosHeader.idCotizacion);
    setCotizacionNumero(datosHeader.idCotizacion || "");
    setCotizacionFecha(datosHeader.fecha);
    setCotizacionInserto(datosHeader.nombreInserto);
    setSucursalNombre(datosHeader.nombreSucursal);
    setFecha(datosHeader.fecha);
    setShowCotizacionPacienteHeader(true);

    try {
      let resultado;
      if (cotizacion.idConvenio) {
        resultado = await ConveniosService.getConvenioPorId(
          cotizacion.idConvenio,
        );
        let empresaCompleta = resultado.convenio[0];
        setEmpresa(empresaCompleta.nombre);
        setSelectedEmpresa(empresaCompleta);

      }
      if (cotizacion.idPaciente) {
        resultado = await PacientesService.getPacientePorId(
          cotizacion.idPaciente,
        );
        let pacienteCompleto = resultado.paciente;
        setSelectedPaciente(pacienteCompleto[0]);
        setNombre(pacienteCompleto[0].nombre);
        setApPaterno(pacienteCompleto[0].apPaterno);
        setApMaterno(pacienteCompleto[0].apMaterno);
        setSexo(pacienteCompleto[0].sexo);
        setFechaNac(pacienteCompleto[0].fechaNacimiento);
        setEdad(pacienteCompleto[0].edad);
        setEmail(pacienteCompleto[0].email);
        setTelefonoCelular(pacienteCompleto[0].telefonoCelular);
        setDireccion(pacienteCompleto[0].direccion);
        setColonia(pacienteCompleto[0].colonia);
        setCPostal(pacienteCompleto[0].cPostal);
        setEstado(pacienteCompleto[0].estado);
        setCiudad(pacienteCompleto[0].ciudad);
        setIne(pacienteCompleto[0].ine);
      }
      resultado = await CotizacionesEstudiosService.getEstudiosPorCotizacion(
        cotizacion.idCotizacion,
      );
      let estudiosCompleto = resultado.estudios;
      const estudiosConDetalles = await Promise.all(
        estudiosCompleto.map(async (estudio) => {
          const estudioPorId = await EstudiosService.getEstudioPorId(
            estudio.idEstudio,
          );
          const [muestras, estudiosInt] = await Promise.all([
            MuestrasService.getMuestrasPorEstudio(estudio.idEstudio),
            EstudiosIntService.getEstudiosPorEstudio(estudio.idEstudio),
          ]);

          return {
            ...estudio,
            codigo: estudioPorId?.codigo || "",
            nombre: estudioPorId?.nombre || "",
            muestras: muestras || [],
            estudiosInt: estudiosInt || [],
          };
        }),
      );
      setEstudios([...estudiosConDetalles, {
        cantidad: "1",
        codigo: "",
        nombre: "",
        costo: "",
        idEstudio: "",
        descuento: "",
      },]);
      setObservaciones(cotizacion.observaciones);
      setValorGeneral(cotizacion.descuentoTotal);
      setSelectedCotizacionId(cotizacion.idCotizacion || null);
      setCotizacionNumero(cotizacion.idCotizacion || "");
      setCotizacionFecha(cotizacion.fecha || "");
      setCotizacionInserto(cotizacion.nombreInserto || "");
      setSucursalNombre(cotizacion.nombreSucursal || "");
      setFecha(cotizacion.fecha || "");
      setOpcionDescuento(cotizacion.tipoDescuento || "");
      try {
        const suc = await SucursalesService.getSucursalIndividual(
          cotizacion.idSucursal,
        );
        setCotizacionSucursalNombre(suc?.nombre || "");

      } catch (err) {
        console.error("Error fetching sucursal:", err);
      }
    } catch (error) {
      console.error(error);
    }

    setEditMode(false);
    setViewOnlyE(true);
    setViewOnlyP(true);
    setEditModeG(true);
    setViewOnly(false);

  };

  async function saveField(fieldName, value) {
    if (!selectedPaciente?.idPaciente) {
      setSnackbar({
        open: true,
        message: "Selecciona un paciente antes de guardar.",
        severity: "warning",
      });
      return;
    }
    if (fieldName === "telefonoCelular" && tieneMasDe10Digitos(value)) {
      mostrarError("El número de teléfono no puede tener más de 10 dígitos.");
      return;
    }
    setSaving((prev) => ({ ...prev, [fieldName]: true }));
    try {
      const payload = { campoN: [fieldName], valorN: value };
      const res = await PacientesService.patchPaciente(
        payload,
        selectedPaciente.idPaciente,
      );
      if (res.data.estatus !== "OK") throw new Error("Error al guardar");
      const updated = res.data.paciente[0];
      setSelectedPaciente((prev) => ({ ...prev, ...updated }));
      setSnackbar({
        open: true,
        message: "Cambios guardados",
        severity: "success",
      });
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: "No se pudo guardar. Intenta de nuevo.",
        severity: "error",
      });
    } finally {
      setSaving((prev) => ({ ...prev, [fieldName]: false }));
    }
  }

  const isEstudioEmpty = (estudio) => {
    const codigo = estudio.codigo ?? "";
    const nombre = estudio.nombre ?? "";
    const idEstudio = estudio.idEstudio ?? "";
    return (
      codigo.toString().trim() === "" &&
      nombre.toString().trim() === "" &&
      idEstudio.toString().trim() === ""
    );
  };

  const removeAllEmpty = (arr) => arr.filter((s) => !isEstudioEmpty(s));
  const tieneUnoConDatos = (arr) => arr.some((s) => !isEstudioEmpty(s));
  function getFormattedNow() {
    const now = new Date();

    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0"); // meses 0-11
    const yyyy = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0"); // 0-23
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${hours}:${minutes}`;
  }

  const agregarCotizacion = async () => {
    let cotizacion;
    let cotizacionUpd;
    const cleaned = removeAllEmpty(estudios);
    let estadoN = estado === "" || estado === "seleccione" ? null : estado;
    const edadNormalizada = edad === "" ? null : normalizarEdad(edad);
    if (!tieneUnoConDatos(cleaned)) {
      mostrarError("Es necesario seleccionar al menos un estudio.");
      return;
    }
    if (errorDescuentoGeneral || erroresDescuentoEstudios.some(Boolean)) {
      mostrarError(
        errorDescuentoGeneral ||
        erroresDescuentoEstudios.find(Boolean) ||
        "Por favor corrige los errores de descuento antes de continuar."
      );
      return;
    }
    if (tieneMasDe10Digitos(telefonoCelular)) {
      mostrarError("El número de teléfono no puede tener más de 10 dígitos.");
      return;
    }
    if (!selectedPaciente && !nombre && !selectedEmpresa) {
      mostrarError(
        "Es necesario seleccionar un paciente o empresa para continuar.",
      );
      return;
    }
    if (selectedPaciente) {
      if (selectedEmpresa) {
        cotizacion = {
          cotizacion: {
            idPaciente: selectedPaciente.idPaciente,
            idConvenio: selectedEmpresa.idConvenio,
            observaciones: observaciones,
            descuentoTotal: valorGeneral,
            tipoDescuento: opcionDescuento,
            conversionSol: conversion,
            idSucursal: currentU.sucursal,
            fecha: getFormattedNow(),
            inserto: currentU.id,
          },
          estudios: cleaned,

        };
      } else {
        cotizacion = {
          cotizacion: {
            idPaciente: selectedPaciente.idPaciente,
            idConvenio: null,
            observaciones: observaciones,
            descuentoTotal: valorGeneral,
            tipoDescuento: opcionDescuento,
            conversionSol: conversion,
            idSucursal: currentU.sucursal,
            fecha: getFormattedNow(),
            inserto: currentU.id,
          },
          estudios: cleaned,
        };
      }
    } else {
      if (selectedEmpresa) {
        cotizacion = {
          paciente: {
            nombre: nombre,
            apPaterno: apPaterno,
            apMaterno: apMaterno,
            fechaNacimiento: fechaNac,
            edad: edadNormalizada,
            sexo: sexo,
            email: email,
            telefonoCelular: telefonoCelular,
            direccion: direccion,
            colonia: colonia,
            cPostal: cPostal,
            estado: estadoN,
            ciudad: ciudad,
            ine: ine,
          },
          cotizacion: {
            idConvenio: selectedEmpresa.idConvenio,
            observaciones: observaciones,
            descuentoTotal: valorGeneral,
            tipoDescuento: opcionDescuento,
            conversionSol: conversion,
            idSucursal: currentU.sucursal,
            fecha: getFormattedNow(),
            inserto: currentU.id,
          },
          estudios: cleaned,
        };

      } else {
        cotizacion = {
          paciente: {
            nombre: nombre,
            apPaterno: apPaterno,
            apMaterno: apMaterno,
            fechaNacimiento: fechaNac,
            edad: edadNormalizada,
            sexo: sexo,
            email: email,
            telefonoCelular: telefonoCelular,
            direccion: direccion,
            colonia: colonia,
            cPostal: cPostal,
            estado: estadoN,
            ciudad: ciudad,
            ine: ine,
          },
          cotizacion: {
            idConvenio: null,
            observaciones: observaciones,
            descuentoTotal: valorGeneral,
            tipoDescuento: opcionDescuento,
            conversionSol: conversion,
            idSucursal: currentU.sucursal,
            fecha: getFormattedNow(),
            inserto: currentU.id,
          },
          estudios: cleaned,
        };

      }
    }
    cotizacionUpd = {
      cotizacion: {
        observacionesN: observaciones,
        descuentoTotalN: valorGeneral,
        tipoDescuentoN: opcionDescuento,
      },
      estudios: cleaned,
    };

    try {
      let resultado;

      if (editModeG) {
        resultado = await CotizacionesService.updateCotizacion(
          cotizacionUpd,
          selectedCotizacionId,
        );
        if (resultado.data.estatus === "OK") {
          const idTarget = selectedCotizacionId;
          setSelectedCotizacionId(idTarget);
          setCotizacionNumero(idTarget || "");
          setEditMode(true);
          setEditModeG(true);
          mostrarPDFCotizacion(idTarget);
        } else {
          mostrarError(
            "No se pudo modificar la cotizacion: " + resultado.data.mensaje,
          );
        }
      } else {
        resultado = await CotizacionesService.agregarCotizacion(cotizacion);
        if (resultado.data.estatus === "OK") {
          let idTarget = resultado.data?.idCotizacion || resultado.data?.id;
          if (!idTarget) {
            try {
              const resCotList = await CotizacionesService.getCotizaciones();
              const lista = resCotList?.data?.cotizaciones || [];
              if (lista.length > 0) {
                const maxId = Math.max(...lista.map(c => Number(c.idCotizacion || 0)));
                if (maxId > 0) idTarget = maxId;
              }
            } catch (e) { }
          }
          setSelectedCotizacionId(idTarget);
          setCotizacionNumero(idTarget || "");
          setEditMode(true);
          setEditModeG(true);
          mostrarPDFCotizacion(idTarget);
        } else {
          mostrarError(
            "No se pudo agregar la cotizacion: " + resultado.data.mensaje,
          );
        }
      }
    } catch (error) {
      mostrarError("Error al actualizar cotizacion:", error);
    }
  };

  return (
    <Layout>
      <Content>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            height: "50%",
            paddingTop: "2vh",
            paddingBottom: "2vh",
          }}
        >
          <Stack spacing={2} sx={{ width: "95vw", maxWidth: "96vw" }}>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperSol"
            >
              <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() =>
                  setSnackbar((prev) => ({ ...prev, open: false }))
                }
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert
                  onClose={() =>
                    setSnackbar((prev) => ({ ...prev, open: false }))
                  }
                  severity={snackbar.severity}
                  sx={{ width: "100%" }}
                >
                  {snackbar.message}
                </Alert>
              </Snackbar>
              {showCotizacionPacienteHeader ? (
                <Grid container spacing={"24vw"} sx={{ display: "flex", justifyContent: "center" }} justifyContent="center">
                  <Stack spacing={2} alignItems="center">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 1.5,

                      }}
                    >
                      <Typography
                        variant="h5"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                          fontWeight: "bold",
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          color: "white",
                          padding: "0.5vw 0.5vw",
                          borderRadius: "8px",
                          display: "inline-block",
                        }}
                      >
                        Cotización #: {selectedCotizacionId ?? "-"}
                      </Typography>
                      <Typography
                        variant="h7"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                          fontWeight: "bold",
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          color: "white",
                          padding: "0.5vw 0.5vw",
                          borderRadius: "8px",
                          display: "inline-block",
                        }}
                      >
                        Sucursal: {sucursalNombre || "-"}
                      </Typography>
                    </Box>
                  </Stack>
                  <Grid item xs={4}>
                    <Stack spacing={1} sx={{ height: "100%" }}>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Box
                          sx={{

                            color: "white",
                            px: 1.5,
                            py: 1,
                            borderRadius: 0.5,
                            minWidth: "45%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="h7"
                            fontWeight="bold"
                            gutterBottom
                            sx={{
                              fontWeight: "bold",
                              background:
                                "linear-gradient(90deg, #006787, #014e65)",
                              color: "white",
                              padding: "0.5vw 0.5vw",
                              borderRadius: "8px",
                              display: "inline-block",
                            }}
                          >
                            Fecha de cotización:
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            background: "#e7eef1",
                            px: 1.5,
                            py: 1,
                            borderRadius: "8px",
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="body2">
                            {fecha || "-"}
                          </Typography>
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Box
                          sx={{
                            color: "white",
                            px: 1.5,
                            py: 1,
                            borderRadius: 0.5,
                            minWidth: "45%",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="h7"
                            fontWeight="bold"
                            gutterBottom
                            sx={{
                              fontWeight: "bold",
                              background:
                                "linear-gradient(90deg, #006787, #014e65)",
                              color: "white",
                              padding: "0.5vw 0.5vw",
                              borderRadius: "8px",
                              display: "inline-block",
                            }}
                          >
                            Insertó:
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            background: "#e7eef1",
                            px: 1.5,
                            py: 1,
                            borderRadius: "8px",
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography variant="body2">
                            {cotizacionInserto || "-"}
                          </Typography>
                        </Box>
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>
              ) : (
                <>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        mb: 1,
                      }}
                    >
                      <Typography
                        variant="h7"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                          fontWeight: "bold",
                          background:
                            "linear-gradient(90deg, #006787, #014e65)",
                          color: "white",
                          padding: "0.5vw 0.5vw",
                          borderRadius: "8px",
                          display: "inline-block",
                          m: 0,
                        }}
                      >
                        PACIENTE:
                      </Typography>

                      {selectedPaciente && selectedPaciente.idPaciente && (
                        <Chip
                          label={`Cantidad de visitas: ${cantidadVisitas}`}
                          sx={{
                            backgroundColor: "#A64341",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "0.95vw",
                            ml: "1vw",
                            height: "auto",
                            padding: "0.4vw 0.8vw",
                            "& .MuiChip-label": {
                              padding: 0,
                            }
                          }}
                        />
                      )}

                      {(viewOnlyP || editMode) && (
                        <Box
                          sx={{
                            position: "absolute",
                            right: 0,
                            display: "flex",
                            gap: "0.5vw",
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={changePaciente}
                            sx={{
                              fontSize: "0.8vw",
                              fontWeight: "bold",
                              backgroundColor: "#9f7003",
                              color: "white",
                              borderRadius: "8px",
                              padding: "0.5vw 1vw",
                              "&:hover": {
                                backgroundColor: "#7e9405",
                                transform: "scale(1.05)",
                              },
                            }}
                            startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                          >
                            Cambiar paciente
                          </Button>
                          <Button
                            variant="contained"
                            onClick={changeEditMode}
                            sx={{
                              fontSize: "0.8vw",
                              fontWeight: "bold",
                              backgroundColor: "#9f7003",
                              color: "white",
                              borderRadius: "8px",
                              padding: "0.5vw 1vw",
                              "&:hover": {
                                backgroundColor: "#7e9405",
                                transform: "scale(1.05)",
                              },
                            }}
                            startIcon={<EditIcon sx={{ fontSize: "1.8vw" }} />}
                          >
                            Editar paciente
                          </Button>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                </>
              )}

              {/* Contenedor principal */}
              <Grid container spacing={"0.3vw"}>
                <Grid
                  item
                  xs={12}
                  container
                  spacing={"1vw"}
                  sx={{ paddingTop: "0.6vw" }}
                >
                  <Stack direction="row" spacing={"3vw"}>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfNombre"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Nombre: <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      {editMode ? (
                        <TextField
                          value={nombre}
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          onChange={(e) => setNombre(e.target.value)}
                          onBlur={(e) => saveField("nombre", e.target.value)}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "12vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfNombre"
                          InputProps={{
                            endAdornment: saving.nombre ? (
                              <CircularProgress size={16} />
                            ) : null,
                          }}
                        />
                      ) : (
                        <Autocomplete
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          options={pacientes}
                          value={selectedPaciente}
                          popupIcon={null}
                          getOptionLabel={(option) =>
                            option
                              ? option.nombre +
                              " " +
                              option.apPaterno +
                              " " +
                              option.apMaterno
                              : ""
                          }
                          onChange={(event, value) => {
                            setSelectedPaciente(value);


                            if (value) {
                              setNombre(value.nombre || "");
                              setApPaterno(value.apPaterno || "");
                              setApMaterno(value.apMaterno || "");
                            }
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.idPaciente ===
                            (value ? value.idPaciente : null)
                          }
                          inputValue={nombre} // controla lo que se ve en el input
                          onInputChange={(event, newInputValue, reason) => {
                            // si el usuario escribe, desvinculamos la selección para que no reemplace el texto
                            if (reason === "input") {
                              setSelectedPaciente(null);
                              setNombre(newInputValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                              value={nombre}
                              onChange={(e) => setNombre(e.target.value)}
                              error={errorNombre}
                              helperText={
                                errorNombre ? "Nombre obligatorio" : ""
                              }
                              sx={{
                                "& .MuiInputBase-root": {
                                  width: "12vw",
                                  height: "5vh",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfNombre"
                            />
                          )}
                          filterOptions={(options, state) => {
                            const input = (state.inputValue || "")
                              .trim()
                              .toLowerCase();
                            if (!input) return options;
                            return options.filter((opt) => {
                              const combined =
                                `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                              return combined.includes(input);
                            });
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfApPaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Paterno:{" "}
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      {editMode ? (
                        <TextField
                          value={apPaterno}
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          onChange={(e) => setApPaterno(e.target.value)}
                          onBlur={(e) => saveField("apPaterno", e.target.value)}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "12vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfApPaterno"
                          InputProps={{
                            endAdornment: saving.apPaterno ? (
                              <CircularProgress size={16} />
                            ) : null,
                          }}
                        />
                      ) : (
                        <Autocomplete
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          options={pacientes}
                          value={selectedPaciente}
                          popupIcon={null}
                          getOptionLabel={(option) =>
                            option
                              ? option.nombre +
                              " " +
                              option.apPaterno +
                              " " +
                              option.apMaterno
                              : ""
                          }
                          onChange={(event, value) => {
                            setSelectedPaciente(value);
                            setViewOnly(true);
                            if (value) {
                              setNombre(value.nombre || "");
                              setApPaterno(value.apPaterno || "");
                              setApMaterno(value.apMaterno || "");
                            }
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.idPaciente ===
                            (value ? value.idPaciente : null)
                          }
                          inputValue={apPaterno}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              setSelectedPaciente(null);
                              setApPaterno(newInputValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              value={apPaterno}
                              disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                              error={errorApPaterno}
                              helperText={
                                errorApPaterno
                                  ? "Apellido paterno obligatorio"
                                  : ""
                              }
                              onChange={(e) => setApPaterno(e.target.value)}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                  width: "12vw",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfApPaterno"
                            />
                          )}
                          filterOptions={(options, state) => {
                            const input = (state.inputValue || "")
                              .trim()
                              .toLowerCase();
                            if (!input) return options;
                            return options.filter((opt) => {
                              const combined =
                                `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                              return combined.includes(input);
                            });
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfApMaterno"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Apellido Materno:
                      </InputLabel>
                      {editMode ? (
                        <TextField
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          value={apMaterno}
                          onChange={(e) => setApMaterno(e.target.value)}
                          onBlur={(e) => saveField("apMaterno", e.target.value)}
                          InputProps={{
                            endAdornment: saving.apMaterno ? (
                              <CircularProgress size={16} />
                            ) : null,
                          }}
                          fullWidth
                          sx={{
                            "& .MuiInputBase-root": {
                              width: "12vw",
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfApMaterno"
                        />
                      ) : (
                        <Autocomplete
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          options={pacientes}
                          value={selectedPaciente}
                          popupIcon={null}
                          getOptionLabel={(option) =>
                            option
                              ? option.nombre +
                              " " +
                              option.apPaterno +
                              " " +
                              option.apMaterno
                              : ""
                          }
                          onChange={(event, value) => {
                            setSelectedPaciente(value);
                            setViewOnly(true);
                            if (value) {
                              setNombre(value.nombre || "");
                              setApPaterno(value.apPaterno || "");
                              setApMaterno(value.apMaterno || "");
                            }
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option.idPaciente ===
                            (value ? value.idPaciente : null)
                          }
                          inputValue={apMaterno}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              setSelectedPaciente(null);
                              setApMaterno(newInputValue);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              disabled={!editMode && (viewOnly || viewOnlyP)}
                              value={apMaterno}
                              onChange={(e) => setApMaterno(e.target.value)}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "5vh",
                                  width: "12vw",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "1vw",
                                  padding: "0.5vw",
                                },
                              }}
                              className="txfApMaterno"
                            />
                          )}
                          filterOptions={(options, state) => {
                            const input = (state.inputValue || "")
                              .trim()
                              .toLowerCase();
                            if (!input) return options;
                            return options.filter((opt) => {
                              const combined =
                                `${opt.nombre || ""} ${opt.apPaterno || ""} ${opt.apMaterno || ""}`.toLowerCase();
                              return combined.includes(input);
                            });
                          }}
                        />
                      )}
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfFechaNacimiento"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Fecha de Nacimiento:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={fechaNac}
                        disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                        onChange={(e) => {
                          const val = e.target.value;
                          setFechaNac(val);
                          const edadCalc = calcularEdadDesdeFechaNacimiento(val);
                          if (edadCalc) {
                            setEdad(edadCalc);
                          }
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          if (editMode && val) {
                            saveField("fechaNacimiento", val);
                            const edadCalc = calcularEdadDesdeFechaNacimiento(val);
                            if (edadCalc) saveField("edad", edadCalc);
                          }
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            width: "12.51vw",
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfFechaNacimiento"
                        type="date"
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <InputLabel
                        htmlFor="txfEdad"
                        sx={{
                          color: "black",
                          fontSize: "1vw",
                          fontWeight: "bold",
                        }}
                      >
                        Edad:
                      </InputLabel>
                      <TextField
                        fullWidth
                        value={edad}
                        disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                        onChange={(e) => setEdad(e.target.value)}
                        onBlur={(e) => {
                          const normal = normalizarEdad(e.target.value);
                          setEdad(normal);
                          if (editMode) saveField("edad", normal);
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "5vh",
                          },
                          "& .MuiInputBase-input": {
                            fontSize: "1vw",
                            padding: "0.5vw",
                          },
                        }}
                        className="txfEdad"
                      />
                    </Grid>
                  </Stack>
                  {/* Sexo y estado civil */}

                  <Grid
                    item
                    xs={12}
                    container
                    spacing={"1vw"}
                    sx={{ paddingTop: "0.4vw" }}
                  >
                    <Stack direction="row" spacing={"3vw"}>
                      <Grid item xs={2}>
                        <FormControl>
                          <FormLabel
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Sexo:
                          </FormLabel>
                          <RadioGroup
                            row
                            value={sexo}
                            error={errorSexo}
                            helperText={errorSexo ? "Obligatorio" : ""}
                            onChange={(e) => {
                              const nuevoSexo = e.target.value;
                              setSexo(nuevoSexo);
                              if (errorSexo && e.target.value.trim() !== "") {
                                setErrorSexo(false);
                              }
                              if (editMode) saveField("sexo", nuevoSexo);
                            }}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          >
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="M"
                              control={
                                <Radio
                                  disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Masculino"
                            />
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="F"
                              control={
                                <Radio
                                  disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Femenino"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={2}>
                        <InputLabel
                          htmlFor="txfEmail"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Email:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onBlur={(e) => {
                            if (editMode) saveField("email", e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfEmail"
                          type="email"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <InputLabel
                          htmlFor="txfTelefono"
                          sx={{
                            color: "black",
                            fontSize: "1vw",
                            fontWeight: "bold",
                          }}
                        >
                          Teléfono:
                        </InputLabel>
                        <TextField
                          fullWidth
                          disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                          value={telefonoCelular}
                          error={tieneMasDe10Digitos(telefonoCelular)}
                          helperText={tieneMasDe10Digitos(telefonoCelular) ? "Máximo 10 dígitos" : ""}
                          onChange={(e) => setTelefonoCelular(e.target.value)}
                          onBlur={(e) => {
                            if (editMode) saveField("telefonoCelular", e.target.value);
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfTelefono"
                        />
                      </Grid>
                    </Stack>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={"1vw"}
                      sx={{ paddingTop: "0.4vw" }}
                    >
                      <Stack direction="row" spacing={"3vw"}>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfDireccion"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Dirección:
                          </InputLabel>
                          <TextField
                            fullWidth
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            value={direccion}
                            onChange={(e) => setDireccion(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("direccion", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfDireccion"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfColonia"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Colonia:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={colonia}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setColonia(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("colonia", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfColonia"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfCPostal"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Código Postal:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={cPostal}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setCPostal(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("cPostal", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfPostal"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="selectEstado"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Estado:
                          </InputLabel>
                          <Select
                            input={<OutlinedInput />}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            value={estado}
                            onChange={(e) => {
                              const nuevoEstado = e.target.value;
                              setEstado(nuevoEstado);
                              if (editMode) saveField("estado", nuevoEstado);
                            }}
                            sx={{
                              flex: "0 0 8vw",
                              width: "12.51vw",
                              maxWidth: "100%",

                              height: "5vh",
                              minHeight: "0px !important",
                              overflow: "hidden",

                              "&.MuiInputBase-root": {
                                minHeight: "0px !important",
                              },

                              "& .MuiSelect-select": {
                                minHeight: "0px !important",
                                padding: "0 0.5vw !important",
                                display: "flex",
                                alignItems: "center",
                                fontSize: "1vw",
                                lineHeight: "1",
                              },

                              "& .MuiOutlinedInput-notchedOutline": {
                                top: 0,
                                "& legend": { display: "none" },
                              },

                              "& .MuiSvgIcon-root": {
                                display: "inline-block !important",
                                position: "absolute",
                                right: "0.5vw",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "1.2vw !important",
                                width: "1.2vw !important",
                                height: "1.2vw !important",
                                pointerEvents: "none",
                              },
                              minWidth: "0px !important",
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                            className="selectEstado"
                          >
                            <MenuItem
                              sx={{
                                fontSize: "1vw",
                                padding: "0.5vw",
                              }}
                              value="seleccione"
                              disabled
                            >
                              Seleccione
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Aguascalientes"
                            >
                              Aguascalientes
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Baja California"
                            >
                              Baja California
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Baja California Sur"
                            >
                              Baja California Sur
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Campeche"
                            >
                              Campeche
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Chiapas"
                            >
                              Chiapas
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Chihuahua"
                            >
                              Chihuahua
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Ciudad de México"
                            >
                              Ciudad de México
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Coahuila"
                            >
                              Coahuila
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Colima"
                            >
                              Colima
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Durango"
                            >
                              Durango
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Estado de México"
                            >
                              Estado de México
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Guanajuato"
                            >
                              Guanajuato
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Guerrero"
                            >
                              Guerrero
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Hidalgo"
                            >
                              Hidalgo
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Jalisco"
                            >
                              Jalisco
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Michoacán"
                            >
                              Michoacán
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Morelos"
                            >
                              Morelos
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Nayarit"
                            >
                              Nayarit
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Nuevo León"
                            >
                              Nuevo León
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Oaxaca"
                            >
                              Oaxaca
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Puebla"
                            >
                              Puebla
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Querétaro"
                            >
                              Querétaro
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Quintana Roo"
                            >
                              Quintana Roo
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="San Luis Potosí"
                            >
                              San Luis Potosí
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Sinaloa"
                            >
                              Sinaloa
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Sonora"
                            >
                              Sonora
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Tabasco"
                            >
                              Tabasco
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Tamaulipas"
                            >
                              Tamaulipas
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Tlaxcala"
                            >
                              Tlaxcala
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Veracruz"
                            >
                              Veracruz
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Yucatán"
                            >
                              Yucatán
                            </MenuItem>
                            <MenuItem
                              sx={{ fontSize: "1vw", padding: "0.5vw" }}
                              value="Zacatecas"
                            >
                              Zacatecas
                            </MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfCiudad"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            Ciudad:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={ciudad}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setCiudad(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("ciudad", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfCiudad"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <InputLabel
                            htmlFor="txfIne"
                            sx={{
                              color: "black",
                              fontSize: "1vw",
                              fontWeight: "bold",
                            }}
                          >
                            INE/Pasaporte:
                          </InputLabel>
                          <TextField
                            fullWidth
                            value={ine}
                            disabled={!editMode && (viewOnly || viewOnlyP || editModeG)}
                            onChange={(e) => setIne(e.target.value)}
                            onBlur={(e) => {
                              if (editMode) saveField("ine", e.target.value);
                            }}
                            sx={{
                              "& .MuiInputBase-root": {
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                fontSize: "1vw",
                                padding: "0.5vw",
                              },
                            }}
                            className="txfIne"
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperLugar"
            >
              {/* Lugar de atencion */}
              <Grid
                item
                xs={12}
                container
                spacing={"1vw"}
                sx={{ paddingTop: "0vw" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="h7"
                    fontWeight="bold"
                    gutterBottom
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      background: "linear-gradient(90deg, #006787, #014e65)",
                      color: "white",
                      padding: "0.5vw 1vw",
                      borderRadius: "8px",
                      display: "inline-block",
                      marginTop: "0vw",
                    }}
                  >
                    EMPRESA:
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12}>
                {!viewOnly && !editModeG ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "0.5vw",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={changeEmpresa}
                      sx={{
                        fontSize: "0.8vw",
                        fontWeight: "bold",
                        backgroundColor: "#9f7003",
                        color: "white",
                        borderRadius: "8px",
                        padding: "0.5vw 1vw",
                        "&:hover": {
                          backgroundColor: "#7e9405",
                          transform: "scale(1.05)",
                        },
                      }}
                      startIcon={<CachedIcon sx={{ fontSize: "1.8vw" }} />}
                    >
                      Cambiar empresa
                    </Button>
                  </Box>
                ) : null}
              </Grid>
              <Grid
                item
                xs={12}
                container
                spacing={"2vw"}
                sx={{ paddingTop: "0.4vw" }}
              >
                <Stack direction="row" spacing={"3vw"}>
                  <Grid item xs={6}>
                    <InputLabel
                      htmlFor="txfNombreEmpresa"
                      sx={{
                        color: "black",
                        fontSize: "1vw",
                        fontWeight: "bold",
                      }}
                    >
                      Nombre:
                    </InputLabel>
                    <Autocomplete
                      disabled={viewOnly || viewOnlyE || editModeG}
                      options={empresas}
                      value={empresa}
                      popupIcon={null}
                      getOptionLabel={(option) => (option ? option.nombre : "")}
                      onChange={async (event, value) => {
                        setSelectedEmpresa(value);
                        setViewOnlyE(true);
                        if (value) {
                          setEmpresa(value.nombre || "");
                        } else {
                          setEmpresa("");
                        }

                        // Determinar la lista de precios a utilizar
                        let nuevaListaId = "";
                        if (value && value.idListaPrecio) {
                          nuevaListaId = value.idListaPrecio;
                        } else {
                          nuevaListaId = await obtenerListaPrecioVigente();
                        }

                        // Actualizar el nombre de la lista en pantalla
                        const nombreL = preciosByLista?.[nuevaListaId]?.nombre ?? "Lista de la sucursal";
                        setSelectedLista(nombreL);

                        // Recalcular costos de estudios que ya están en la tabla
                        if (nuevaListaId) {
                          setEstudios((prevEstudios) =>
                            prevEstudios.map((estudio) => {
                              if (!estudio.idEstudio) return estudio;
                              const listaPreciosObj = preciosByLista[nuevaListaId];
                              const nuevoCosto =
                                listaPreciosObj &&
                                  listaPreciosObj.precios &&
                                  listaPreciosObj.precios[estudio.idEstudio] !== undefined
                                  ? listaPreciosObj.precios[estudio.idEstudio]
                                  : "";
                              return {
                                ...estudio,
                                costo: nuevoCosto,
                              };
                            })
                          );
                        }
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option.idConvenio === (value ? value.idConvenio : null)
                      }
                      inputValue={empresa}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          disabled={viewOnlyE || editModeG || viewOnly}
                          value={empresa}
                          sx={{
                            "& .MuiInputBase-root": {
                              height: "5vh",
                              width: "60vw",
                            },
                            "& .MuiInputBase-input": {
                              fontSize: "1vw",
                              padding: "0.5vw",
                            },
                          }}
                          className="txfNombreEmpresa"
                        />
                      )}
                      filterOptions={(options, state) => {
                        const input = (state.inputValue || "")
                          .trim()
                          .toLowerCase();
                        if (!input) return options;
                        return options.filter((opt) => {
                          const combined = `${opt.nombre || ""}`.toLowerCase();
                          return combined.includes(input);
                        });
                      }}
                    />
                  </Grid>
                </Stack>
              </Grid>
            </Paper>

            <Paper
              elevation={3}
              sx={{ p: 2, borderRadius: 4 }}
              className="paperSelEstudios"
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h9"
                  gutterBottom
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 1vw",
                    borderRadius: "8px",
                    display: "inline-block",
                  }}
                >
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    Seleccionar Estudios
                  </Box>{" "}
                  <Box component="span" sx={{ fontWeight: "normal" }}>
                    (Esta utilizando la lista de precios: {selectedLista ? (<Chip label={selectedLista} sx={{ backgroundColor: "#e08505", color: "white", fontWeight: "bold" }} />) : (null)})
                  </Box>
                </Typography>
              </Box>

              <Table sx={{ backgroundColor: "white", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                {" "}
                <TableHead sx={{ backgroundColor: "#18234f" }}>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Cantidad
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Codigo
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Nombre del estudio
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Costo
                    </TableCell>
                    {opcionDescuento !== "ninguno" && (
                      <TableCell
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Descuento
                      </TableCell>
                    )}
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Info.
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "white",
                        fontWeight: "bold",
                        borderBottom: "none",
                        borderRight: "1px solid #ccc",
                      }}
                    >
                      Eliminar
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {estudios.length > 0 ? (
                    estudios.map((estudio, index) => (
                      <React.Fragment key={index}>
                        <TableRow>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                value={estudio.cantidad}
                                onChange={(e) =>
                                  handleChangeEstudio(
                                    index,
                                    "cantidad",
                                    e.target.value,
                                  )
                                }
                                disabled={viewOnly}
                                sx={{
                                  width: "10vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <Autocomplete
                                options={estudiosOptions}
                                disabled={viewOnly}
                                popupIcon={null}
                                getOptionKey={(option) => option.idEstudio}
                                getOptionLabel={(option) =>
                                  (option && option.codigo) || ""
                                }
                                value={
                                  estudiosOptions.find(
                                    (o) => o.idEstudio === estudio.idEstudio,
                                  ) || null
                                }
                                onChange={(e, value) => {
                                  enrichEstudioSelection(index, value);
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  option.idEstudio ===
                                  (value ? value.idEstudio : null)
                                }
                                filterOptions={(options, state) =>
                                  filterAndRankEstudios(options, state.inputValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    disabled={viewOnly}
                                    sx={{
                                      width: "12vw",
                                      "& .MuiInputBase-root": {
                                        height: "5vh",
                                        paddingRight: "8px !important",
                                      },
                                      "& .MuiInputBase-input": {
                                        fontSize: "1vw",
                                        paddingRight: "4px !important",
                                      },
                                      "& .MuiAutocomplete-inputRoot": {
                                        paddingRight: "8px !important",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <Autocomplete
                                options={estudiosOptions}
                                disabled={viewOnly}
                                popupIcon={null}
                                getOptionKey={(option) => option.idEstudio}
                                getOptionLabel={(option) => {
                                  if (!option) return "";
                                  if (typeof option === "string") return option;
                                  return `${option.nombre || ""}${option.codigo ? ` (${option.codigo})` : ""}`;
                                }}
                                value={
                                  estudiosOptions.find(
                                    (o) => o.idEstudio === estudio.idEstudio,
                                  ) || null
                                }
                                onChange={(e, value) => {
                                  enrichEstudioSelection(index, value);
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  option.idEstudio ===
                                  (value ? value.idEstudio : null)
                                }
                                filterOptions={(options, state) =>
                                  filterAndRankEstudios(options, state.inputValue)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    disabled={viewOnly}
                                    sx={{
                                      width: "24vw",
                                      minWidth: "24vw",
                                      "& .MuiInputBase-root": {
                                        height: "5vh",
                                        paddingRight: "8px !important",
                                      },
                                      "& .MuiInputBase-input": {
                                        fontSize: "1vw",
                                        paddingRight: "4px !important",
                                      },
                                      "& .MuiAutocomplete-inputRoot": {
                                        paddingRight: "8px !important",
                                      },
                                    }}
                                    className="txfNombreEstudioInt"
                                  />
                                )}
                              />
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "0.2vw",
                              }}
                            >
                              <span style={{ fontSize: "1.8vw", fontWeight: "bold", color: "#18234f" }}>$</span>
                              <TextField
                                value={estudio.costo}
                                disabled={viewOnly}
                                sx={{
                                  width: "8vw",
                                  "& .MuiInputBase-root": {
                                    height: "5vh",
                                  },
                                  "& .MuiInputBase-input": {
                                    fontSize: "1vw",
                                  },
                                }}
                              />
                            </Box>
                          </TableCell>
                          {opcionDescuento !== "ninguno" && (
                            <TableCell>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: "0.2vw",
                                }}
                              >
                                <span style={{ fontSize: "1.8vw", fontWeight: "bold", color: "#18234f" }}>
                                  {opcionDescuento === "porcentaje" ? "%" : "$"}
                                </span>
                                <TextField
                                  sx={{
                                    width: "8vw",
                                    "& .MuiInputBase-root": {
                                      height: "5vh",
                                    },
                                    "& .MuiInputBase-input": {
                                      fontSize: "1vw",
                                    },
                                  }}
                                  value={estudio.descuento || ""}
                                  disabled={viewOnly}
                                  onChange={(e) =>
                                    handleChangeEstudio(
                                      index,
                                      "descuento",
                                      e.target.value,
                                    )
                                  }
                                />
                                {erroresDescuentoEstudios[index] && (
                                  <Typography
                                    sx={{
                                      color: "#d32f2f",
                                      fontSize: "0.65vw",
                                      fontWeight: "bold",
                                      mt: "0.2vw",
                                      textAlign: "center",
                                    }}
                                  >
                                    {erroresDescuentoEstudios[index]}
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                          )}
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <IconButton
                                onClick={() => mostrarInfo(estudio)}
                                sx={{
                                  color: "#006787",
                                  padding: 0,
                                  transition:
                                    "transform 0.2s ease, color 0.2s ease",
                                  "&:hover": {
                                    color: "#014e65",
                                    transform: "scale(1.5)",
                                  },
                                }}
                              >
                                <InfoIcon sx={{ fontSize: "1.8vw" }} />
                              </IconButton>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Button
                              size="large"
                              sx={{ color: "red" }}
                              onClick={() => handleRemoveEstudio(index)}
                            >
                              <DeleteIcon sx={{ fontSize: "1.8vw" }} />
                            </Button>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={opcionDescuento !== "ninguno" ? 7 : 6}
                        align="center"
                        sx={{ py: 4 }}
                      >
                        No hay registros
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "2vw",
                }}
              >
                <Typography
                  variant="h9"
                  gutterBottom
                  sx={{
                    background: "linear-gradient(90deg, #006787, #014e65)",
                    color: "white",
                    padding: "0.5vw 1vw",
                    borderRadius: "8px",
                    display: "inline-block",
                    whiteSpace: "pre-line",
                    textAlign: "center",
                  }}
                >
                  <Box
                    component="span"
                    sx={{ fontWeight: "bold", justifyContent: "center" }}
                  >
                    Coloque sus observaciones y/o comentarios
                  </Box>
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: "1vw",
                }}
              >
                <TextField
                  fullWidth
                  onChange={(e) =>
                    setObservaciones(e.target.value)}
                  disabled={viewOnly}
                  value={observaciones}
                  multiline
                  minRows={1}
                  maxRows={4}
                  sx={{
                    "& .MuiInputBase-root": {},
                    "& .MuiInputBase-input": {
                      fontSize: "1vw",
                    },
                  }}
                />
              </Box>

              <Stack
                direction="row"
                spacing={"10vw"}
                sx={{ paddingTop: "4vw" }}
              >
                <Table sx={{ backgroundColor: "white", width: "12vw", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  {" "}
                  <TableHead sx={{ backgroundColor: "#18234f" }}>
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        sx={{
                          color: "white",
                          fontWeight: "bold",
                          borderBottom: "none",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        Descuentos
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <FormControl>
                          <RadioGroup
                            disabled={viewOnly}
                            value={opcionDescuento}
                            onChange={(e) =>
                              handleChangeOpcionDescuento(e.target.value)
                            }
                          >
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="porcentaje"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Porcentaje"
                            />
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="cantidad"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Cantidad"
                            />
                            <FormControlLabel
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "1vw",
                                  fontWeight: "bold",
                                },
                              }}
                              value="ninguno"
                              control={
                                <Radio
                                  disabled={viewOnly}
                                  sx={{
                                    "& .MuiSvgIcon-root": {
                                      height: "1vw",
                                      width: "1vw",
                                    },
                                  }}
                                />
                              }
                              label="Ninguno"
                            />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                      {opcionDescuento !== "ninguno" && (
                        <TableCell>
                          <Typography
                            sx={{
                              backgroundColor: "#172149",
                              width: "10vw",
                              color: "white",
                              fontSize: "1vw",
                              padding: "0.3vw 0.5vw",
                              borderRadius: "6px",
                              textAlign: "center",
                              marginBottom: "0.5vw",
                            }}
                          >
                            {opcionDescuento === "cantidad"
                              ? "Coloque cantidad a descontar:"
                              : "Coloque porcentaje general:"}
                          </Typography>
                          <TextField
                            value={valorGeneralMostrado}
                            disabled={viewOnly}
                            onChange={(e) =>
                              handleChangeValorGeneral(e.target.value)
                            }
                            sx={{
                              width: "11vw",
                              "& .MuiInputBase-root": {
                                height: "5vh",
                              },
                              "& .MuiInputBase-input": {
                                textAlign: "center",
                                fontSize: "0.9vw",
                              },
                            }}
                          />
                          {errorDescuentoGeneral && (
                            <Typography
                              sx={{
                                color: "#d32f2f",
                                fontSize: "0.7vw",
                                fontWeight: "bold",
                                mt: "0.2vw",
                                textAlign: "center",
                              }}
                            >
                              {errorDescuentoGeneral}
                            </Typography>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
                <Table sx={{ backgroundColor: "white", width: "12vw", "& .MuiTableCell-root": { padding: "4px 8px" } }}>
                  {" "}
                  <TableBody>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "#18234f",
                          color: "white",
                          fontWeight: "bold",
                        }}
                      >
                        Total
                      </TableCell>
                      <TableCell>$ {totalCotizacion.toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "#18234f",
                          color: "white",
                          fontWeight: "bold",
                        }}
                      >
                        Descuento
                      </TableCell>
                      <TableCell>$ {descuentoTotal.toFixed(2)}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "#18234f",
                          color: "white",
                          fontWeight: "bold",
                        }}
                      >
                        Neto
                      </TableCell>
                      <TableCell>$ {netoCotizacion.toFixed(2)}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Stack>
            </Paper>
          </Stack>
        </Box>
        <Box
          sx={{
            position: "fixed",
            right: "6vw",
            top: "30%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {!viewOnly && (
            <Tooltip
              title={"Generar cotización"}
              arrow
              placement="right"
              slotProps={{
                popper: {
                  sx: {
                    [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                    {
                      marginTop: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                    {
                      marginBottom: "0.2vw",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                    {
                      marginLeft: "0px",
                    },
                    [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                    {
                      marginRight: "0px",
                    },
                  },
                },
                tooltip: {
                  sx: {
                    fontSize: "0.7vw",
                    padding: "0.5vw 0.5vw",
                    borderRadius: "8px",
                    backgroundColor: "rgba(255,255,255,0.9)",
                    fontWeight: "bold",
                    fontFamily: "Roboto-Medium",
                    color: "#000000",
                    marginBottom: "-5px",
                  },
                },
                arrow: {
                  sx: {
                    color: "rgba(255,255,255,0.9)",
                  },
                },
              }}
            >
              <IconButton
                disabled={Boolean(errorDescuentoGeneral || erroresDescuentoEstudios.some(Boolean))}
                onClick={agregarCotizacion}
                sx={{
                  backgroundColor: "#ffffff",
                  color: "#18234f",
                  "&:hover": { backgroundColor: "#d1d1d1" },
                  "&.Mui-disabled": { backgroundColor: "#e0e0e0", color: "#9e9e9e" },
                  width: "4vw",
                  height: "4vw",
                }}
              >
                <PrintIcon sx={{ fontSize: "1.8vw" }} />
              </IconButton>
            </Tooltip>
          )}
          {(viewOnly || viewOnlyP || editMode || editModeG || Boolean(selectedCotizacionId)) && (
            <>
              <Tooltip
                title={"Enviar por correo"}
                arrow
                placement="right"
                slotProps={{
                  popper: {
                    sx: {
                      [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                      {
                        marginTop: "0px",
                      },
                      [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                      {
                        marginBottom: "0.2vw",
                      },
                      [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                      {
                        marginLeft: "0px",
                      },
                      [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                      {
                        marginRight: "0px",
                      },
                    },
                  },
                  tooltip: {
                    sx: {
                      fontSize: "0.7vw",
                      padding: "0.5vw 0.5vw",
                      borderRadius: "8px",
                      backgroundColor: "rgba(255,255,255,0.9)",
                      fontWeight: "bold",
                      fontFamily: "Roboto-Medium",
                      color: "#000000",
                      marginBottom: "-5px",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "rgba(255,255,255,0.9)",
                    },
                  },
                }}
              >
                <IconButton
                  onClick={handleEnviarCorreoCotizacion}
                  sx={{
                    backgroundColor: "#ffb300",
                    color: "white",
                    "&:hover": { backgroundColor: "#ff8f00" },
                    width: "4vw",
                    height: "4vw",
                  }}
                >
                  <EmailIcon sx={{ fontSize: "1.8vw" }} />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={"Enviar por WhatsApp"}
                arrow
                placement="right"
                slotProps={{
                  popper: {
                    sx: {
                      [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                      {
                        marginTop: "0px",
                      },
                      [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                      {
                        marginBottom: "0.2vw",
                      },
                      [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                      {
                        marginLeft: "0px",
                      },
                      [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                      {
                        marginRight: "0px",
                      },
                    },
                  },
                  tooltip: {
                    sx: {
                      fontSize: "0.7vw",
                      padding: "0.5vw 0.5vw",
                      borderRadius: "8px",
                      backgroundColor: "rgba(255,255,255,0.9)",
                      fontWeight: "bold",
                      fontFamily: "Roboto-Medium",
                      color: "#000000",
                      marginBottom: "-5px",
                    },
                  },
                  arrow: {
                    sx: {
                      color: "rgba(255,255,255,0.9)",
                    },
                  },
                }}
              >
                <IconButton
                  onClick={handleEnviarTicketWhatsAppCotizacion}
                  sx={{
                    backgroundColor: "#25d366",
                    color: "white",
                    "&:hover": { backgroundColor: "#128c7e" },
                    width: "4vw",
                    height: "4vw",
                  }}
                >
                  <WhatsAppIcon sx={{ fontSize: "1.8vw" }} />
                </IconButton>
              </Tooltip>
            </>
          )}
          <Tooltip
            title={"Nueva cotización"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
              onClick={reloadPage}
            >
              <AddIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={"Buscar cotización"}
            arrow
            placement="right"
            slotProps={{
              popper: {
                sx: {
                  [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
                  {
                    marginTop: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: "0.2vw",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
                  {
                    marginLeft: "0px",
                  },
                  [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
                  {
                    marginRight: "0px",
                  },
                },
              },
              tooltip: {
                sx: {
                  fontSize: "0.7vw",
                  padding: "0.5vw 0.5vw",
                  borderRadius: "8px",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  fontWeight: "bold",
                  fontFamily: "Roboto-Medium",
                  color: "#000000",
                  marginBottom: "-5px",
                },
              },
              arrow: {
                sx: {
                  color: "rgba(255,255,255,0.9)",
                },
              },
            }}
          >
            <IconButton
              onClick={mostrarBuscarCotizaciones}
              sx={{
                backgroundColor: "#ffffff",
                color: "#18234f",
                "&:hover": { backgroundColor: "#d1d1d1" },
                width: "4vw",
                height: "4vw",
              }}
            >
              <SearchIcon sx={{ fontSize: "1.8vw" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Content>
    </Layout>
  );
};
export default Cotizaciones;
